import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import { Chart } from "react-google-charts";
import { Paper } from "@material-ui/core";
import { Table } from "@material-ui/core";
import { TableBody } from "@material-ui/core";
import { TableContainer } from "@material-ui/core";
import { TableHead } from "@material-ui/core";
import { TablePagination } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { TableSortLabel } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import { makeStyles, Checkbox } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import SweetAlert from 'react-bootstrap-sweetalert';
import {
  Input,
  Button,
  Modal,
  Header,
  Icon,
  Loader,
  Segment,
  TextArea,
  Dropdown,
} from "semantic-ui-react";
import PropTypes from "prop-types";
import IndustryDropDown from "../reusable/industrydropdown";
import CountryDropDown from "../reusable/CountryDropDownById";
import ClientDropDown from "../reusable/ClientRegCorp";
import CCEList from "../reusable/CCEList";
import SalesManagerDDL from "../reusable/SalesManagerDDL";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as XLSX from 'xlsx';
import ExcelExport from 'react-excel-export';
import "react-toastify/dist/ReactToastify.css";
import "../rajkumar/Custom.css";
import { NotificationContainer, NotificationManager } from "react-notifications";

const axios = require("axios");
//const [selectedRow, setSelectedRow] = useState(null);

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    fontSize: 14,
  },
}));

function BSTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}
const headCells = [
  { id: "UserName", numeric: false, disablePadding: false, label: "CCE" },
  { id: "URL", numeric: false, disablePadding: false, label: "URL" },
  { id: "From Date", numeric: false, disablePadding: false, label: "From Date", disableSorting: true },
  { id: "TotalNR", numeric: true, disablePadding: false, label: "TotalNR" },
  { id: "TotalNR1", numeric: true, disablePadding: false, label: "TotalNR1" },
  { id: "Frequency", numeric: true, disablePadding: false, label: "Frequency" },
  {
    id: "Clients",
    numeric: true,
    disablePadding: false,
    label: "Clients",
    disableSorting: true,
  },
  {
    id: "CountryName",
    numeric: false,
    disablePadding: false,
    label: "Country",
  },

  // {
  //   id: "PotentialRevenue",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Potential Revenue",
  //   disableSorting: true,
  // },

  // {
  //   id: "NoofEmployee",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "# of Employee",
  //   disableSorting: true,
  // },

  {
    id: "Actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
    disableSorting: true,
  },
];
const headCells1 = [
  {
    id: "AssignmentId",
    numeric: false,
    disablePadding: false,
    label: "AssignmentId",
  },
  { id: "Date", numeric: false, disablePadding: false, label: "Date" },
  { id: "Course", numeric: false, disablePadding: false, label: "Course" },
  { id: "Feedback", numeric: false, disablePadding: false, label: "Feedback" },
];
const headCellTenPlus = [
  { id: "CCE", numeric: false, disablePadding: false, label: "CCE" },
  { id: "URL", numeric: false, disablePadding: false, label: "URL" },
  {
    id: "NR",
    numeric: false,
    disablePadding: false,
    label: "NR",
  },
];
const headCellScs = [
  { id: "SCId", numeric: false, disablePadding: false, label: "SCId" },
  { id: "Client", numeric: false, disablePadding: false, label: "Client" },
  {
    id: "Date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
  {
    id: "TotalNR",
    numeric: false,
    disablePadding: false,
    label: "TotalNR",
  },
];


const headCellQuot = [
  { id: "QuotationId", numeric: false, disablePadding: false, label: "QuotationId" },
  { id: "Quotation_status", numeric: false, disablePadding: false, label: "Quotation status" },
  {
    id: "Client",
    numeric: false,
    disablePadding: false,
    label: "Client",
  },
  {
    id: "TotalNR",
    numeric: false,
    disablePadding: false,
    label: "TotalNR",
  },
  {
    id: "Pax",
    numeric: false,
    disablePadding: false,
    label: "No Of Pax",
  },
  {
    id: "Date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
];

const headCellMedianData = [
  { id: "CCECode", numeric: false, disablePadding: false, label: "CCE Code" },
  { id: "CceName", numeric: false, disablePadding: false, label: "CCE" },
  { id: "Manager", numeric: false, disablePadding: false, label: "Manager" },
  { id: "NoOfCorporate", numeric: true, disablePadding: false, label: "NoOfCorporate" },
  {
    id: "TotalRegCorpNR",
    numeric: false,
    disablePadding: false,
    label: "TotalNR",
  },
  {
    id: "AverageNR_perRegularCorporate",
    numeric: false,
    disablePadding: false,
    label: "AverageNR",
  },
  {
    id: "MedianNR",
    numeric: false,
    disablePadding: false,
    label: "MedianNR",
  },
];
const headCellMOMs = [
  { id: "Date", numeric: false, disablePadding: false, label: "Date" },
  { id: "Remarks", numeric: false, disablePadding: false, label: "Remarks" },
];
const headCellClients = [
  { id: "Name", numeric: false, disablePadding: false, label: "Name" },
  { id: "Email", numeric: false, disablePadding: false, label: "Email" },
];
const headCellClientsTemp = [
  { id: "Name", numeric: false, disablePadding: false, label: "Name" },
  {
    id: "Actions",
    numeric: false,
    disablePadding: false,
    label: "Action",
    disableSorting: true,
  },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function FeedbackTable(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCells1.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
FeedbackTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function TenPlusTable(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCellTenPlus.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
TenPlusTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function MedianTable(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCellMedianData.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function SCsTable(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCellScs.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
SCsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};


function QuotationTable(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCellQuot.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
QuotationTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function MOMsTable(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCellMOMs.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
MOMsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function URLClientsTable(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCellClients.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
URLClientsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function URLClientsTableTemp(props) {
  const { classes } = props;
  return (
    <TableHead>
      <TableRow>
        {headCellClientsTemp.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
URLClientsTableTemp.propTypes = {
  classes: PropTypes.object.isRequired,
};

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    classes,
    // onSelectAllClick,
    order,
    orderBy,
    // numSelected,
    // rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (

          <TableCell
            key={headCell.id === "TotalNR" ? "TotalNR1" : headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={
              orderBy === (headCell.id === "TotalNR" ? "TotalNR1" : headCell.id)
                ? order
                : false
            }
            style={
              headCell.id === "TotalNR1" ? { display: "none" } : { display: "" }
            }
          >
            {headCell.disableSorting ? (
              headCell.label
            ) : (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={
                  orderBy ===
                    (headCell.id === "TotalNR" ? "TotalNR1" : headCell.id)
                    ? order
                    : "desc"
                }
                onClick={createSortHandler(
                  headCell.id === "TotalNR" ? "TotalNR1" : headCell.id
                )}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "asc" ? "sorted ascending" : "sorted descending"}
                  </span>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  // numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.object.isRequired,
  // rowCount: PropTypes.number.isRequired,
};

export default function RCB() {
  const [loading, set_loading] = useState(true);
  const [data_list, set_data_list] = useState([]);
  const [openaddcorporate, setOpenAddCorporate] = useState(false);
  const [openeditcorporate, setOpenEditCorporate] = useState(false);
  const [openfeedback, setOpenFeedback] = useState(false);
  const [modalFeedback, modalFeedbackData] = useState([]);
  const [opengraph, setOpenGraph] = useState(false);
  const [modalgraphdata, modalGraphData] = useState([]);
  const [opentenplus, setOpenTenPlus] = useState(false);
  const [modalTenPlus, modalTenPlusData] = useState([]);
  const [openscs, setOpenSCs] = useState(false);
  const [openQuot, setOpenQuot] = useState(false);
  const [MedianData, Set_OpenMedianData] = useState(false);
  const [modalMedianData, setmodalMedianData] = useState([]);
  const [modalSCs, modalSCsData] = useState([]);
  const [modalQuotation, modalQuotationData] = useState([]);
  const [openmoms, setOpenMOMs] = useState(false);
  const [openexpand, setOpenExpand] = useState(false);
  const [openSensitive, setOpenSensitive] = useState(false);
  const [modalMOMs, modalMOMsData] = useState([]);
  const [useremailid, UserEmailId] = useState(null);
  const [username, UserName] = useState(null);
  const [openclientsforurl, setOpenClientsForUrl] = useState(false);
  const [modalClientsForUrl, modalClientsForUrlData] = useState([]);
  const [txtareareserve, txtAreaReserve] = useState("");
  const [sensitiveReason, setSensitiveReason] = useState("");
  const [show_list, set_show_list] = React.useState("none");
  const [searchResults, setSearchResults] = React.useState([]);
  const [setclientexistornot, Set_ClientExistOrNot] = useState({});
  const [approvalcode, Set_ApprovalCode] = useState({});
  const [openapproval, Set_OpenApproval] = useState(false);
  const [openfaq, Set_OpenFAQ] = useState(false);
  const [faq, Set_FAQ] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const initialList = [];

  const [tempclient, TempClient] = useState(initialList);
  const [urlcce, UrlCce] = useState([]);

  // --- RCB Claim-from-CSM (Graph-gated contact transfer) -------------------
  const [openClaimModal, setOpenClaimModal] = useState(false);
  const [claimConflicts, setClaimConflicts] = useState([]); // [{clientId, clientName, clientEmail, oldCSMUserId, oldCSMName, corporateId, corporateUrl, status, reason, newDate, oldDate}]
  const [claimOriginalObjPost, setClaimOriginalObjPost] = useState(null);
  // ------------------------------------------------------------------------

  function handleRemovetemp(id) {
    const newList = tempclient.filter((x) => x.id !== id);
    if (newList != null) TempClient(newList);
  }

  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [imgupload, setImageUpload] = useState(false);
  const [imgupload1, setImageUpload1] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [file, setFile] = useState("");

  const [urlId, set_UrlId] = useState(0);
  const [NoOfDays, set_NoOfDays] = useState(0);
  const [LastCCE, set_LastCCE] = useState(0);
  const [cceEmailId, set_cceEmailId] = useState("");
  const [industry, set_industrylist] = useState([]);
  const [industryId, set_IndustryId] = useState(0);
  const [industryname, set_IndustryName] = useState("");
  const [country, set_country] = useState([]);
  const [countryId, set_CountryId] = useState(0);
  const [countryname, set_CountryName] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("0")
  const [cce, set_CCE] = useState([]);
  const [cceid, set_CCEId] = useState(0);
  const [ccename, set_CCEName] = useState("");
  const [managerid, set_MANAGERId] = useState(0);
  const [managername, set_MANAGERName] = useState("");
  const [clientid, set_ClientId] = useState(0);
  const [clientname, set_ClientName] = useState("");
  const [withoutcce, withOutCCE] = useState({});
  const [corporatescbutnotregularcorporate, CorporateScButNotRegularCorporate] = useState({});
  const [freedomain, freeDomain] = useState({});
  const [url, setUrl] = useState("");
  const originalUrlRef = React.useRef("");
  const [secondUrl, setSecondUrl] = useState("");
  const [secondUrlReason, setSecondUrlReason] = useState("");
  // Multi-domain support (2026-07): unlimited additional domains per corporate.
  // Each entry: { Domain, Reason, id? (0 for new/unsaved) }. Legacy CorporateURL.SecondURL/Reason
  // is transparently folded in by Proc_RCB_GetAdditionalDomains until first save.
  const [additionalDomains, setAdditionalDomains] = useState([]);
  const [openReasonPopup, setOpenReasonPopup] = useState(false);
  const [reasonPopupText, setReasonPopupText] = useState("");

  // Claimable-status precomputed flags (from Proc_RCB_GetClaimableFlags).
  // Key format: "<UrlID>|<CSMUserId>" -> { IsClaimable, LatestMOMDate, LatestEmailDate, LatestTeamsDate, LastComputedAt }
  const [claimableMap, setClaimableMap]           = useState({});
  const [showOnlyClaimable, setShowOnlyClaimable] = useState(false);
  const [openClaimableReason, setOpenClaimableReason] = useState(false);
  const [claimableReasonRow, setClaimableReasonRow]   = useState(null);
  const [approval_code, setApprovalCode] = useState("");
  const [commonname, set_CommonName] = useState("");
  const [forrevival, set_ForRevival] = useState({});
  const [marquee, set_Marquee] = useState({});
  const [empanel, set_Empanel] = useState({});
  const [noempanel, set_NoEmpanel] = useState({});
  const [data1, set_data1] = useState([]);
  const [month, set_Month] = useState({});
  const [nr, set_NR] = useState({});
  const [nrLess, set_NRLess] = useState({});
  const [userid, UserId] = useState(0);
  let fileInput = React.createRef();
  const [source, set_source] = useState(null);
  const [ismanager, Set_IsManager] = useState({});
  const [PotentialRevenu, set_PotentialRevenu] = useState(0);
  const [NoofEmp, set_NoofEmp] = useState(0);
  const [VenddorCode, set_VendorCode] = useState("");

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const recordsAfterPagingAndSorting = () => {
    return stableSort(
      filterFn.fn(data_list),
      getComparator(order, orderBy)
    ).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  };

  const [rows, setRows] = useState([]);

  const handleIncrement = (rowIndex) => {
    const newRows = [...rows];
    newRows[rowIndex].Frequency += 1;
    setRows(newRows);
  }

  const handleDecrement = (rowIndex) => {
    const newRows = [...rows];
    if (newRows[rowIndex].Frequency > 0) {
      newRows[rowIndex].Frequency -= 1;
    }
    setRows(newRows);
  }


  function getDownloadPP(Path) {
    // alert(Path);
    // if (Path != null && Path != "")
    //     return (
    //         <img className="ml-5" src={'http://koshish.koenig-solutions.com/api/yusuf/get_img?file_name=icon-balck.png'} alt='DP'></img>
    //     )
    debugger;
    if (Path != null && Path != "") {
      axios
        .get("rajkumar/get_img?file_name=" + Path + "", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          debugger;
          const base64 = btoa(
            new Uint8Array(response.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          set_source("data:;base64," + base64);
        });
    }
  }

  const handleSearch = (e) => {
    let target = e.target;
    let filter_data = data1.filter((d) => {
      //console.log(d.CountryName)
      if (d.CountryName !== null) {
        return (
          d.UserName.toLowerCase().includes(target.value.toLowerCase()) ||
          d.URL.toLowerCase().includes(target.value.toLowerCase()) || d.CountryName.toLowerCase().includes(target.value.toLowerCase())
        );
      }
      else {
        return (
          d.UserName.toLowerCase().includes(target.value.toLowerCase()) ||
          d.URL.toLowerCase().includes(target.value.toLowerCase())
        );
      }
    });
    set_data_list(filter_data);
  };

  // const handleMoreThanNumber = (e) => {
  //   let target = e.target;

  //   let filter_data = [];
  //   if (target.value != "") {
  //     filter_data = data1.filter((x) => {
  //       return parseInt(x.TotalNR) > parseInt(target.value);
  //     });
  //   } else {
  //     filter_data = data1;
  //     return filter_data;
  //   }
  //   set_data_list(filter_data);
  // };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data_list.length - page * rowsPerPage);

  useEffect(() => {
    let d = localStorage.getItem("emp_data");
    if (d != null) {
      UserEmailId(JSON.parse(d).email_id);
      UserName(JSON.parse(d).UserName);
      UserId(JSON.parse(d).user_id);
    }
    set_loading(true);

    if (JSON.parse(d).CountryId == 93) {
      get_data(2, 0, "", 0, "", 0, 0, 0, 12, 0, 0, 0, 0);
    }
    else {
      setSelectedCountryId(JSON.parse(d).CountryId)
      get_data(2, 0, "", 0, "", JSON.parse(d).CountryId, 0, 0, 12, 0, 0, 0, 0);
    }
    get_country();
    get_industry();
    get_cce();

    withOutCCE({ withoutcce: false });
    CorporateScButNotRegularCorporate({ corporatescbutnotregularcorporate: false });
    freeDomain({ freedomain: false });
    set_ForRevival({ forrevival: false });
    set_Marquee({ marquee: false });
    set_Empanel({ empanel: false });
    set_NoEmpanel({ noempanel: false });
    set_Month({ month: 0 });
    set_NR({ nr: 0 });
    set_NRLess({ nrLess: 0 });
    Set_ClientExistOrNot({ setclientexistornot: false });
    Set_ApprovalCode({ approvalcode: false });
    Set_IsManager({ ismanager: false });
    //setImageUpload({ imgupload: false });
  }, []);

  // useEffect(() => {
  //   debugger;
  //   Set_IsManager({ismanager:false});
  // }, [ismanager.ismanager]);
  // useEffect(() => {
  //   debugger;
  //   Set_IsManager({ismanager: true});
  // }, [!ismanager.ismanager]);


  useEffect(() => {
    Set_ClientExistOrNot({ setclientexistornot: false });
  }, [setclientexistornot.setclientexistornot]);

  useEffect(() => {
    if (setclientexistornot.setclientexistornot === true) {
      alert("this client linked with another corporate");
      handleRemovetemp(clientid);
      return;
    }
  }, [!setclientexistornot.setclientexistornot]);

  useEffect(() => {

    Set_ApprovalCode(true);
  }, [approvalcode.approvalcode]);

  // useEffect(() => {
  //   debugger;
  //   setImageUpload(true);
  // }, [imgupload]);

  useEffect(() => {
    if (approvalcode.approvalcode === true) {
      alert("you must enter valid code for approval");
      return;
    }
  }, [!approvalcode.approvalcode]);

  // useEffect(() => {
  //   set_loading(true);
  //   get_country();
  //   get_industry();
  //   get_cce();

  //   withOutCCE({ withoutcce: false });
  //   freeDomain({ freedomain: false });
  //   set_ForRevival({ forrevival: false });
  //   set_Marquee({ marquee: false });
  //   set_Empanel({ empanel: false });
  //   set_NoEmpanel({ noempanel: false });
  //   set_Month({ month: 0 });
  //   set_NR({ nr: 0 });
  //   Set_ClientExistOrNot({ setclientexistornot: false });
  //   Set_ApprovalCode({ approvalcode: false });
  //   set_SaveData({ savedata: false });
  //   get_data(2, 0, "", 0, "", 0, 0, 0, 12, 0);
  //   set_loading(false);
  // }, [!savedata.savedata]);

  // Handles file upload event and updates state
  // function handleUpload(event) {
  //
  //   setFile(event.target.files[0]);
  //   saveRCLogo(event.target.files[0]);
  // }

  const handleChangelogo = (e) => {
    debugger;
    const file = e.target.files[0]; // accesing file
    setFile(file); // storing file
    console.warn("hello : " + file.name);
    setImageUpload1(true);
  };

  const handleUpload = () => {
    const file_data = new FormData();
    file_data.append("smfile", file);
    setImageUpload(true);

    axios
      .post("rajkumar/upload", file_data, {
        // headers: {
        //   'Content-Type': 'multipart/form-data'
        // }
      })
      .then((response) => {
        if (response.status.toString() === "200") {
          getDownloadPP(file.name);
          // setFile(response.data);
          // console.log("handleUpload :" +e.target.files[0])
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  //Component to display thumbnail of image
  // const ImageThumb = ({ image }) => {
  //
  //   return (
  //     <img
  //       id="saveImgrcbLogo"
  //       src={URL.createObjectURL(image)}
  //       alt={image.name}
  //       onClick={onclick}
  //     />
  //   );
  // };

  const handleRemove = () => {
    setFile("");
    set_source(null);
    fileInput.current.value = null;
  };

  function get_cce() {
    axios
      .get("priya/sp_ClientTrackingProject?type=7")
      .then(function (response) {
        set_CCE(response.data);
      })
      .catch(function (error) {
        alert(error);
      });
  }

  async function get_industry() {
    await axios
      .get("rajkumar/GetIndustryList")
      .then(function (response) {
        set_industrylist(response.data);
      })
      .catch(function (error) {
        alert(error);
      });
  }

  async function get_country() {
    await axios
      .get("rajkumar/GetCountryById?Type=3")
      .then(function (response) {
        set_country(response.data);
      })
      .catch(function (error) {
        alert(error);
      });
  }
  // a

  async function get_FAQ() {
    debugger;
    set_loading(true);
    try {
      let { data } = await axios.get("rajkumar/GetFAQ?Type=16");
      if (data.length > 0) {
        Set_FAQ(data[0]["HtmlContent"].toString());
        Set_OpenFAQ(true);
        set_loading(false);
      } else {
        //alert("NO DATA");

        Set_OpenFAQ(true);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function get_ExcelPPC() {
    try {
      set_loading(true);
      console.log(userid.toString());
      let { data } =
        await axios.get(
          "rajkumar/ManagerOrNot?Type=30&UserId=" + userid.toString() + ""
        )
      debugger;
      if (data.length > 0) {
        get_Excel1PPC();
      }
      else {
        alert("You do not have access");
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
    }
  }

  async function get_Excel() {
    try {
      set_loading(true);
      console.log(userid.toString());
      let { data } =
        await axios.get(
          "rajkumar/ManagerOrNot?Type=29&UserId=" + userid.toString() + ""
        )
      debugger;
      if (data.length > 0) {
        get_Excel1();
      }
      else {
        alert("You do not have access");
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
    }
  }

  async function get_Excel1() {
    debugger;
    //set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/SeeAllRCB?Type=18" +
        "&CCE=" +
        cceid +
        "&URL=" +
        url +
        "&withOutCCE=" +
        (withoutcce.withoutcce ? 1 : 0) +
        "&email=''" +
        "&CountryId=" +
        countryId +
        "&FreeDomain=" +
        (freedomain.freedomain ? 1 : 0) +
        "&ForRevival=" +
        (forrevival.forrevival ? 1 : 0) +
        "&Month=" +
        (month.month === 0 ? 12 : month.month) +
        "&NR=" +
        (nr.nr === 0 ? 0 : nr.nr) +
        "&Manager=" +
        managerid + "&UserId=" + userid.toString() +
        ""
      );
      // get_data(
      //   2,
      //   cceid,
      //   url,
      //   withoutcce.withoutcce ? 1 : 0,
      //   "",
      //   countryId,
      //   freedomain.freedomain ? 1 : 0,
      //   forrevival.forrevival ? 1 : 0,
      //   month.month === 0 ? 12 : month.month,
      //   nr.nr === 0 ? 0 : nr.nr,
      //   managerid
      // );
      // console.log(data);
      // const fileName = 'example.xlsx';

      // const exportFile = new ExcelExport();
      // exportFile.addSheet(JSON.stringify(data), 'Sheet 1');
      // exportFile.save(fileName);
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
      //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workbook, "DataSheet.xlsx");
      set_loading(false);
    } catch (er) {
      //console.log('ashish');
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function get_Excel1PPC() {
    debugger;
    try {
      let { data } = await axios.get(
        "rajkumar/SeeAllRCB?Type=31" +
        "&CCE=" +
        cceid +
        "&URL=" +
        url +
        "&withOutCCE=" +
        (withoutcce.withoutcce ? 1 : 0) +
        "&email=''" +
        "&CountryId=" +
        countryId +
        "&FreeDomain=" +
        (freedomain.freedomain ? 1 : 0) +
        "&ForRevival=" +
        (forrevival.forrevival ? 1 : 0) +
        "&Month=" +
        (month.month === 0 ? 12 : month.month) +
        "&NR=" +
        (nr.nr === 0 ? 0 : nr.nr) +
        "&Manager=" +
        managerid + "&UserId=" + userid.toString() +
        ""
      );
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "DataSheet.xlsx");
      set_loading(false);
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }


  // ===========================================================================
  // Second-domain "bonafide reason" AI validation.
  //
  // Called from both the Add-Corporate and Edit-Corporate save handlers before
  // sending SaveAllRCBData. Only runs when secondUrl has a value.
  //
  // Flow:
  //   1. Send { systemPrompt, userMessage } to POST /rajkumar/OpenAIClassify
  //      (server-side wrapper around OpenAI; the key never touches the browser).
  //   2. Backend replies { reply: "BONAFIDE" | "NOT_BONAFIDE" | other }.
  //   3. If the reply is unrecognized OR the endpoint errors, fall back to a
  //      length heuristic (>= 30 chars) so real reasons still go through.
  // ===========================================================================
  const SECOND_URL_SYSTEM_PROMPT = `You are helping validate reasons for adding an ADDITIONAL business domain to an existing Regular Corporate in a CRM used by a service delivery / consulting company.

A reason is BONAFIDE when it points at a concrete, verifiable business fact. ANY of the following count:

Same-entity reasons (the additional domain belongs to the primary corporate itself):
  - the company operates under two legal entities
  - an acquisition or merger introduced a subsidiary with a different domain
  - a regional branch or country office runs its own portal
  - a rebrand is in progress with both the old and new domains still active
  - a spin-off, joint venture, or partnership uses a distinct domain
  - a different product line, brand, or service arm of the same parent company

Client / partner reasons (the additional domain belongs to an entity the primary corporate works WITH):
  - an end client, customer, or delivery beneficiary of the primary corporate uses this domain
    (e.g. "Jeddah Airport is MDSA's end client for whom we are delivering training/services")
  - a major vendor, supplier, contractor, or channel partner of the primary corporate
  - a system integrator / consulting firm engaged by the primary corporate
  - a subcontractor delivering work on behalf of / alongside the primary corporate
  - a co-branded engagement, alliance, or long-running partner account
  - a training / education delivery is happening at a client site

Rule of thumb: the reason describes a real, named business relationship (subsidiary / partner / client / vendor / delivery target) tied to the primary corporate, even if the two entities are separate companies. That IS bonafide.

A reason is NOT BONAFIDE when it is any of:
  - blank, single word, or generic filler ("test", "ok", "yes", "N/A", "-", "sample", "abc")
  - a personal or non-business reason ("I want it", "for practice", "just adding")
  - vague and unspecific with no named party or relationship ("company has more domains", "additional domain", "extra site", "another one")
  - a pure placeholder ("adding for now", "will update later", "TBD", "to be decided")
  - promotional / self-serving with no verifiable fact

Respond with EXACTLY one token: BONAFIDE or NOT_BONAFIDE. No punctuation, no explanation.`;

  const SECOND_URL_USER_TEMPLATE = `Additional Domain URL: {SECOND_URL}
Reason provided by the CSM:
"""
{REASON}
"""`;

  async function validateSecondUrlReasonAI(secondUrl, secondUrlReason) {
    const reason = (secondUrlReason || "").trim();
    if (!secondUrl) return { valid: true };
    if (!reason) return { valid: false, message: "Please provide a Bonafide reason for adding the Second Domain." };

    const userMessage = SECOND_URL_USER_TEMPLATE
      .replace(/\{SECOND_URL\}/g, secondUrl)
      .replace(/\{REASON\}/g, reason);

    let aiText = "";
    let aiOk = false;
    try {
      const { data } = await axios.post("rajkumar/OpenAIClassify", {
        systemPrompt: SECOND_URL_SYSTEM_PROMPT,
        userMessage:  userMessage,
      });
      aiText = (data && (data.reply || data.response || data.answer || data.text)) || "";
      aiOk = true;
    } catch (e) {
      console.log("[secondUrl-ai] request err:", e && e.message);
    }

    // Length-based fallback: kicks in when AI is unreachable OR when the proxy returns an
    // unrecognized/broken response (e.g. current server issue where /Shubhi/ChatGPT returns
    // "Cannot perform runtime binding" for every payload shape). Accepts any substantive
    // reason (>= 30 chars), rejects short filler like "test", "ok", "N/A".
    function fallbackByLength() {
      if (reason.length < 30) {
        return { valid: false, message: "Reason must be at least 30 characters describing a genuine business relationship (subsidiary, partner, end client, delivery target, etc.)." };
      }
      return { valid: true };
    }

    if (!aiOk) return fallbackByLength();

    const upper = String(aiText).toUpperCase();
    // Guard: some server responses contain "NOT" but not "NOT BONAFIDE" (e.g. "Cannot perform
    // runtime binding"). Only reject on an explicit "NOT BONAFIDE" phrase.
    if (upper.indexOf("NOT BONAFIDE") >= 0 || upper.indexOf("NOT_BONAFIDE") >= 0) {
      return {
        valid: false,
        message: "Reason not accepted as a bonafide business justification. Please provide more specific detail (legal entity split, acquisition, regional portal, end client, delivery target, etc.).\n\nAI note: " + aiText,
      };
    }
    if (upper.indexOf("BONAFIDE") >= 0) {
      return { valid: true };
    }
    // AI responded but didn't contain either token (broken proxy, unexpected model output, etc.).
    // Fall back to the length heuristic rather than fail-closed — otherwise legit reasons get
    // wrongly rejected whenever the AI is misbehaving.
    console.log("[secondUrl-ai] unrecognized AI response, falling back to length heuristic. Response was:", aiText);
    return fallbackByLength();
  }

  // --------- Additional Domains (multi-domain support) ---------
  function addDomainRow() {
    setAdditionalDomains(prev => [...prev, { Domain: "", Reason: "", id: 0 }]);
  }
  function removeDomainRow(idx) {
    setAdditionalDomains(prev => prev.filter((_, i) => i !== idx));
  }
  function updateDomainField(idx, field, value) {
    setAdditionalDomains(prev => prev.map((d, i) => i === idx ? { ...d, [field]: value } : d));
  }
  async function loadAdditionalDomainsForUrl(urlId) {
    if (!urlId) { setAdditionalDomains([]); return; }
    try {
      const { data } = await axios.get("rajkumar/AdditionalDomains?UrlID=" + urlId);
      // _origDomain / _origReason snapshot what was loaded from DB so validateAllDomainsAI
      // can skip re-validating unchanged rows (AI is non-deterministic and would occasionally
      // reject reasons that were already approved on a previous save).
      const rows = (data || []).map(r => ({
        Domain:      r.Domain || "",
        Reason:      r.Reason || "",
        id:          r.Id || 0,
        _origDomain: r.Domain || "",
        _origReason: r.Reason || "",
      }));
      setAdditionalDomains(rows);
    } catch (e) {
      console.log("loadAdditionalDomains err:", e && e.message);
      setAdditionalDomains([]);
    }
  }
  // Runs AI validation against every row. Returns { valid, message, invalidIndex }.
  // Skips AI for rows whose Domain+Reason match what was originally loaded from DB
  // (already-approved data; re-checking would let AI flakiness block unrelated saves).
  async function validateAllDomainsAI(rows) {
    for (let i = 0; i < rows.length; i++) {
      const d = rows[i];
      if (!d.Domain || !d.Domain.trim()) {
        return { valid: false, message: "Row " + (i + 1) + ": Domain cannot be empty.", invalidIndex: i };
      }
      if (!d.Reason || !d.Reason.trim()) {
        return { valid: false, message: "Row " + (i + 1) + " (" + d.Domain + "): please provide a Bonafide reason.", invalidIndex: i };
      }
      const unchanged =
        typeof d._origDomain === "string" &&
        typeof d._origReason === "string" &&
        d.Domain.trim().toLowerCase() === d._origDomain.trim().toLowerCase() &&
        d.Reason.trim()             === d._origReason.trim();
      if (unchanged) continue;
      const check = await validateSecondUrlReasonAI(d.Domain, d.Reason);
      if (!check.valid) {
        return { valid: false, message: "Row " + (i + 1) + " (" + d.Domain + "): " + check.message, invalidIndex: i };
      }
    }
    return { valid: true };
  }
  // Persists the domain list. For Add flow (UrlID=0), the backend resolves UrlID from Url + CSMUserId.
  async function persistAdditionalDomains(urlIdOrZero, url, csmUserId) {
    try {
      await axios.post("rajkumar/SaveAdditionalDomains", {
        UrlID:     urlIdOrZero || 0,
        Url:       url,
        CSMUserId: csmUserId,
        UserId:    userid,
        Domains:   additionalDomains.map(d => ({ Domain: d.Domain.trim(), Reason: d.Reason.trim() })),
      });
    } catch (e) {
      console.log("persistAdditionalDomains err:", e && e.message);
      // Non-fatal for the user: the corporate save already succeeded. Surface a soft alert.
      alert("Corporate saved, but additional domains could not be persisted:\n" + (e.message || e));
    }
  }

  async function save_data(objPost) {
    var objPost1 = {
      Type: "13",
      objPost: objPost,
    };
    // console.log(IsManager(objPost[0]._cceid, objPost[0]._userid));
    set_loading(true);
    let { data } = await axios.post(
      "rajkumar/SaveAllRCBData",
      JSON.parse(JSON.stringify(objPost1))
    );
    console.log(data);
    if (data[0].Output == 'More Than Fifty') {
      alert("You can not add more than 50 corporate");
      set_loading(false);
      get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
    }
    if (data[0].Output == 'More Than 40') {
      alert(data[0].Output2);
      set_loading(false);
      get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
    }
    else if (data[0].Output == 'Below Median NR') {
      alert("You can not add more than 20 corporate as your average NR per regular corporate is less than 10 Lacs.");
      set_loading(false);
      get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
    }
    else if (data[0].Output == 'Resigned') {
      alert("You can't claim corporates in resignation period");
      set_loading(false);
      get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
    }
    else if (data[0].Output !== 'Yes') {
      // Conflict path: some clients are mapped to other CSMs. Resolve owners and open Claim modal.
      const output = data[0].Output;
      console.log("RCB conflict:", output);
      try {
        await resolveAndOpenClaimModal(output, objPost);
      } catch (e) {
        console.log("resolveAndOpenClaimModal err:", e);
        alert(
          "Some clients are already mapped with other CSMs:\n\n" + output +
          "\n\nClaim flow could not be opened. Please retry."
        );
      }
      set_loading(false);
      get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
    }
    else {
      if (data.length > 0) {
        alert("Action completed. NR will be updated shortly via Script. Please check after 1.5 hour");
        set_loading(false);
        get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
      } else {
        alert("Action completed. NR will be updated shortly via Script. Please check after 1.5 hour");
        set_loading(false);
      }
    }
    try {
      if (data[0].Output2 != "" && data[0].Output2 != null && data[0].Output2 != undefined && data[0].Output2 != "0") {
        console.log(data[0].Output2, data[0].Output3);
        // const greeting = data[0].Output2.split(";").length > 1 ? "Dear CSMs" : "Dear CSM";
        const greeting = "";

        const corporateName = objPost[0]._Url ? objPost[0]._Url : '[Corporate Name]';
        const userName = data[0].Output3 ? 'under ' + data[0].Output3 : '';

        const bodyWithGreeting = `${greeting}\nA new regular corporate ${corporateName} has been added ${userName} that already exists. Please review the entry to avoid duplication.`;

        sendMailForReserve(
          'shubham.verma@koenig-solutions.com',
          data[0].Output2,
          '',
          'shubham.verma@koenig-solutions.com',
          'Existing Corporate Added - ' + objPost[0]._Url,
          bodyWithGreeting)
      }

    }
    catch { }
  }

  // ===========================================================================
  // RCB Claim-from-CSM helpers
  //
  // Proc_RCB Type=13 already returns the conflict as a pre-formatted string:
  //   "email1@x.com is mapped with CSM-A-Name, email2@y.com is mapped with CSM-B-Name"
  // We parse it directly -- no UrlCCEs/ClientsForRC chain needed.
  //
  // On Claim click, the backend (/ClaimCorporateFromCSM) does everything atomically:
  //   StdId lookup -> Graph email+Teams check -> Proc_RCB_ContactTransfer SP -> notify.
  // ===========================================================================
  function parseConflictOutput(output) {
    // Server returns XML-escaped concatenation; entities first.
    const txt = String(output || "")
      .replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    return txt.split(",").map(s => s.trim()).filter(Boolean).map(piece => {
      const m = piece.match(/^(.*?)\s+is\s+mapped\s+with\s+(.*)$/i);
      return m
        ? { clientEmail: m[1].trim(), oldCSMName: m[2].trim() }
        : { clientEmail: piece, oldCSMName: "(unknown)" };
    });
  }

  function resolveAndOpenClaimModal(conflictOutput, originalObjPost) {
    const row = originalObjPost && originalObjPost[0];
    if (!row) return;
    const newCorporateID = row._URLId;
    const corporateUrl   = row._Url || "";
    // Claim REQUIRES an explicit CSM selection (no fallback to logged-in user).
    // Add-without-CSM is allowed for normal saves (orphan corporate) but a claim must be
    // attributed to a real owner. If CSM is empty, drop back to the old plain-alert path.
    const newCSMUserId   = row._cceid;
    if (!newCSMUserId || parseInt(newCSMUserId, 10) === 0) {
      alert(
        "Some clients are already mapped with other CSMs:\n\n" + conflictOutput +
        "\n\nTo claim a contact you must first select a CSM from the dropdown, " +
        "then save again."
      );
      return;
    }

    // === CLAIM DEBUG === remove once flow is verified
    console.log("[CLAIM DEBUG] originalObjPost[0] =", row);
    console.log("[CLAIM DEBUG] extracted -> newCorporateID:", newCorporateID,
                "| corporateUrl:", corporateUrl, "| newCSMUserId:", newCSMUserId,
                "| (_cceid:", row._cceid, " _userid:", row._userid, ")");
    console.log("[CLAIM DEBUG] raw conflictOutput:", conflictOutput);

    const parsed = parseConflictOutput(conflictOutput);
    if (parsed.length === 0) return;
    console.log("[CLAIM DEBUG] parsed conflicts:", parsed);

    const conflicts = parsed.map(p => ({
      newCorporateID,
      corporateUrl,
      newCSMUserId,
      clientEmail: p.clientEmail,
      oldCSMName: p.oldCSMName,
      status: "pending",  // pending | checking | done | rejected | error
      reason: null,
      newDate: null,
      oldDate: null,
    }));

    setClaimConflicts(conflicts);
    setClaimOriginalObjPost(originalObjPost);
    setOpenClaimModal(true);
  }

  async function handleClaim(index) {
    const conflicts = claimConflicts.slice();
    const c = conflicts[index];
    if (!c || c.status === "checking" || c.status === "done") return;

    // === CLAIM DEBUG === remove once flow is verified
    console.log("[CLAIM DEBUG] handleClaim row:", c);

    if (!c.clientEmail || !c.newCSMUserId || (!c.newCorporateID && !c.corporateUrl)) {
      console.log("[CLAIM DEBUG] guard FAILED ->",
        "clientEmail:", c.clientEmail,
        "| newCSMUserId:", c.newCSMUserId,
        "| newCorporateID:", c.newCorporateID,
        "| corporateUrl:", c.corporateUrl);
      conflicts[index] = { ...c, status: "error", reason: "MissingConflictData" };
      setClaimConflicts(conflicts);
      return;
    }

    conflicts[index] = { ...c, status: "checking" };
    setClaimConflicts(conflicts.slice());

    let resp;
    try {
      const { data } = await axios.post("rajkumar/ClaimCorporateFromCSM", {
        ClientContactEmail: c.clientEmail,
        NewCSMUserId:       c.newCSMUserId,
        NewCorporateID:     c.newCorporateID,
        CorporateUrl:       c.corporateUrl,
      });
      resp = data;
    } catch (e) {
      // === CLAIM DEBUG === remove once flow is verified
      console.log("[CLAIM DEBUG] axios error:", e.message,
                  "| status:", e.response && e.response.status,
                  "| response.data:", e.response && e.response.data);
      const backendReason = (e.response && e.response.data && e.response.data.reason) || "RequestFailed";
      conflicts[index] = { ...c, status: "error", reason: backendReason };
      setClaimConflicts(conflicts.slice());
      return;
    }

    // v2 response shape: { allowed, reason?, csm1: {...}, csm2: {...}, windows, sp? }
    const csm1 = resp.csm1 || {};
    const csm2 = resp.csm2 || {};
    const newDate = csm2.latestClientReply || null;
    const oldDate = csm1.latestClientReply || null;

    if (!resp.allowed) {
      conflicts[index] = { ...c, status: "rejected", reason: resp.reason, newDate, oldDate, csm1, csm2 };
      setClaimConflicts(conflicts.slice());
      return;
    }

    conflicts[index] = { ...c, status: "done", newDate, oldDate, csm1, csm2 };
    setClaimConflicts(conflicts.slice());
  }

  function closeClaimModal() {
    setOpenClaimModal(false);
    setClaimConflicts([]);
    setClaimOriginalObjPost(null);
    get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
  }

  async function saveRCLogo(file) {
    if (file !== null && file !== "" && file !== "undefined") {
      const file_data = new FormData();
      file_data.append("sampleFile", file);

      await axios.post("yusuf/upload", file_data, {}).then((res) => {
        // if (res.status == 200) {
        //   setFile(res.data);
        // }
      });
    }
  }

  async function get_data(
    Type,
    CCE,
    URL,
    withOutCCE,
    email,
    CountryId,
    FreeDomain,
    ForRevival,
    Month,
    NR,
    NR_Less,
    Manager,
    CorporateScButNotRegularCorporate
  ) {
    console.log(NR_Less);
    let { data } = await axios.get(
      "rajkumar/SeeAllRCB?Type=" +
      Type +
      "&CCE=" +
      CCE +
      "&URL=" +
      URL +
      "&withOutCCE=" +
      withOutCCE +
      "&email=" +
      email +
      "&CountryId=" +
      CountryId +
      "&FreeDomain=" +
      FreeDomain +
      "&ForRevival=" +
      ForRevival +
      "&Month=" +
      Month +
      "&NR=" +
      NR +
      "&Manager=" +
      Manager +
      "&NR_Less=" +
      NR_Less +
      "&corporatescbutnotregularcorporate=" +
      CorporateScButNotRegularCorporate + "&UserId=" + userid.toString() +
      ""
    );

    // Merge in claimable flags (precomputed nightly by RCBInactiveCleanup service).
    let flagMap = {};
    try {
      const { data: flags } = await axios.get("rajkumar/ClaimableFlags");
      (flags || []).forEach(f => {
        const key = String(f.UrlID) + "|" + String(f.CSMUserId);
        flagMap[key] = f;
      });
    } catch (e) { console.log("ClaimableFlags fetch err:", e && e.message); }
    setClaimableMap(flagMap);

    // Merge in additional domains for each corporate (multi-domain support).
    let domainsByUrl = {};
    try {
      const { data: allDomains } = await axios.get("rajkumar/AllAdditionalDomains");
      (allDomains || []).forEach(d => {
        const k = String(d.UrlID);
        if (!domainsByUrl[k]) domainsByUrl[k] = [];
        domainsByUrl[k].push({ Domain: d.Domain, Reason: d.Reason });
      });
    } catch (e) { console.log("AllAdditionalDomains fetch err:", e && e.message); }

    const decorate = (row) => {
      const key = String(row.CorporateID) + "|" + String(row.UserId);
      const f = flagMap[key];
      return {
        ...row,
        _isClaimable: !!(f && f.IsClaimable),
        _claimableInfo: f || null,
        _additionalDomains: domainsByUrl[String(row.CorporateID)] || [],
      };
    };
    const enriched = (data || []).map(decorate);

    if (enriched.length > 0) {
      set_loading(false);
      set_data_list(enriched);
      set_data1(enriched);
    } else {
      //alert("NO DATA");
      set_loading(false);
      set_data_list(enriched);
      set_data1(enriched);
    }
  }

  function openClaimableReasonFor(row) {
    setClaimableReasonRow(row);
    setOpenClaimableReason(true);
  }

  async function getFeedback(URL) {
    set_loading(true);
    try {
      let { data } = await axios.get("rajkumar/Feedbacks?URL=" + URL + "");
      if (data.length > 0) {
        modalFeedbackData(data);
        setOpenFeedback(true);
        set_loading(false);
      } else {
        //alert("NO DATA");

        modalFeedbackData(data);
        setOpenFeedback(true);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function getTenPlus(GreaterThenAmount) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/Usp_TotalNRperYear?GreaterThenAmount=" +
        GreaterThenAmount +
        ""
      );
      if (data.length > 0) {
        modalTenPlusData(data);
        setOpenTenPlus(true);
        set_loading(false);
      } else {
        modalTenPlusData(data);
        setOpenTenPlus(true);
        //alert("NO DATA");
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function get_MedianData() {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/MedianData"
      );
      if (data.length > 0) {
        setmodalMedianData(data);
        Set_OpenMedianData(true);
        set_loading(false);
      } else {
        setmodalMedianData(data);
        Set_OpenMedianData(true);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function getModalSCs(Type, URL, CCE, month) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/SCs?Type=" + Type + "&URL=" + URL + "&CCE=" + CCE + "&Month=" + (month.month === 0 ? 12 : month.month) + ""
      );
      if (data.length > 0) {
        modalSCsData(data);
        setOpenSCs(true);
        set_loading(false);
      } else {
        modalSCsData(data);
        setOpenSCs(true);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function getModalQuotation(Type, URL, CCE, month) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/Quotation?Type=" + Type + "&URL=" + URL + "&CCE=" + CCE + "&Month=" + (month.month === 0 ? 12 : month.month) + ""
      );
      if (data.length > 0) {
        modalQuotationData(data);
        setOpenQuot(true);
        set_loading(false);
      } else {
        modalQuotationData(data);
        setOpenQuot(true);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function getModalMOMs(CceId, Url) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/MOMs?CceId=" + CceId + "&Url=" + Url + ""
      );
      if (data.length > 0) {
        modalMOMsData(data);
        setOpenMOMs(true);
        set_loading(false);
      } else {
        modalMOMsData(data);
        setOpenMOMs(true);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function deleteCorporate(CceId, Url) {
    set_loading(true);
    try {
      // let { data } = await axios.get(
      //   "rajkumar/DeleteCorporateRCB?CceId=" + CceId + "&Url=" + Url + "&Type=19" + ""
      // );
      if (window.confirm("Do you want to delete corporate?") == true) {

        alert('Corporate deleted succesfully');
        let { data } = await axios.get(
          "rajkumar/DeleteCorporateRCB?CceId=" + CceId + "&Url=" + Url + "&Type=19" + ""
        );
        get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
        set_loading(false);
      } else {
        set_loading(false);
      }

    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  const hideAlert = () => {
    ReactDOM.render("", document.getElementById('getSweetModel'));
  }

  async function marksensitive(Url, row) {
    set_loading(true);
    try {
      console.log(sensitiveReason + ' @ ' + Url + " @ " + row)

      let { data } = await axios.get(
        "rajkumar/sensitiveCorporateRCB?Url=" + Url + "&Type=21" + "&Reason=" + sensitiveReason + ""
      );
      get_data(2, 0, "", 0, "", 0, 0, 0, 12, 0, 0, 0, 0);
      alert('Corporate marked sensitive succesfully');
      set_loading(false);

    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  // function getSweetalert(Url, row) {
  //   ReactDOM.render(<SweetAlert
  //     title="Sensitive Reason"
  //     customClass="sweetAlertWidth50"
  //     showCloseButton={true}
  //     confirmBtnText="Save"
  //     cancelBtnText="Close"
  //     confirmBtnBsStyle="secondary"
  //     onConfirm={() => marksensitive(Url, row)}
  //     onCancel={() => { hideAlert(); }}>
  //     <div id="FeedbackContent"><TextArea
  //       id="txtareaClaim"
  //       rows={2}
  //       placeholder="Mention reason you want to acquire this corporate"
  //       style={{
  //         width: '100%',
  //         padding: '10px',
  //         borderRadius: '5px',
  //         border: '1px solid #ccc',
  //         fontFamily: 'Arial, sans-serif',
  //         fontSize: '14px',
  //         lineHeight: '1.6',
  //       }}
  //       onChange={handleSensitiveReason}
  //     /></div>
  //   </SweetAlert>, document.getElementById('getSweetModel'))
  // }


  const ViewReason = (Reason) => {
    // ReactDOM.render(<SweetAlert
    //   title="Sensitive Reason"
    //   customClass="sweetAlertWidth50"
    //   showCloseButton={true}
    //   cancelBtnText="Close"
    //   onCancel={() => { hideAlert(); }}>
    //   <div id="FeedbackContent">{Reason}</div>
    // </SweetAlert>, document.getElementById('getSweetModel'))

    ReactDOM.render(<SweetAlert title="Sensitive Reason" customClass="sweetAlertWidth50"
      onConfirm={() => hideAlert()} onCancel={() => hideAlert()}><div id="FeedbackContent"><h2>{Reason == '' ? 'Not Available' : Reason}</h2></div></SweetAlert>, document.getElementById('getSweetModel'))
  }



  async function getModalUrlCCEs(Type, URLId) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/UrlCCEs?Type=" + Type + "&URLId=" + URLId + ""
      );
      if (data.length > 0) {
        UrlCce(data);
        // setOpenSCs(true);
        // set_loading(false);
      } else {
        UrlCce(data);
        // alert("NO DATA");
        // set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function getModalGraph(Type, CCE, URL) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/Graph?Type=" + Type + "&CCE=" + CCE + "&URL=" + URL + ""
      );
      if (data.length > 0) {
        const json = data;
        const currentYear = new Date().getFullYear();
        const yearNames = [(currentYear - 3).toString(), (currentYear - 2).toString(), (currentYear - 1).toString(), (currentYear).toString()];
        const chartData = [
          ["Month", ...yearNames, "URLAlloc"],
        ];

        for (let i = 0; i < json.length; i++) {
          chartData.push([
            json[i].Months,
            parseInt(json[i].NR1, 10),
            parseInt(json[i].NR2, 10),
            parseInt(json[i].NR3, 10),
            parseInt(json[i].NR4, 10),
            parseInt(json[i].CCEAlloc, 10),
          ]);
        }
        modalGraphData(chartData);
        setOpenGraph(true);
        set_loading(false);
      } else {
        setOpenGraph(true);
        //alert("NO DATA");
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function getModalClientsForURL(Type, Url, CCEId) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/ClientsForURL?Type=" +
        Type +
        "&Url=" +
        Url +
        "&CCEId=" +
        CCEId +
        ""
      );

      if (data.length > 0) {
        modalClientsForUrlData(data);
        setOpenClientsForUrl(true);
        set_loading(false);
      } else {
        //alert("NO DATA");
        modalClientsForUrlData(data);
        setOpenClientsForUrl(true);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function getClientsForRC(Type, UrlId, CCE) {
    try {
      let { data } = await axios.get(
        "rajkumar/ClientsForRC?Type=" +
        Type +
        "&UrlId=" +
        UrlId +
        "&CCE=" +
        CCE +
        ""
      );

      if (data.length > 0) {
        TempClient(data);
      } else {
        //alert("NO DATA");
        TempClient(data);
        set_loading(false);
      }
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function search(d) {
    if (d.length != "") {
      set_show_list("");
      setSearchResults.value = null;

      // Only search when user has typed something before @ and at least 3 characters after @
      var atIndex = d.indexOf("@");
      if (atIndex < 1 || d.length - atIndex - 1 < 3) {
        setSearchResults([]);
        return;
      }

      // Domain must match the primary URL OR any additional domain (multi-domain support).
      var typedDomain = d.substring(atIndex + 1).toLowerCase().trim();
      var urlDomain = (url || "").replace("@", "").toLowerCase().trim();
      // Build the full allowed-domain list: primary + every additional domain currently in state.
      // additionalDomains folds in the legacy CorporateURL.SecondURL via the load SP, so we don't
      // need a separate legacy-secondUrl check here anymore.
      var allowedDomains = [];
      if (urlDomain) allowedDomains.push(urlDomain);
      (additionalDomains || []).forEach(function (row) {
        var dd = (row.Domain || "").replace("@", "").toLowerCase().trim();
        if (dd && allowedDomains.indexOf(dd) < 0) allowedDomains.push(dd);
      });

      var typedMatchesAny = allowedDomains.some(function (dd) {
        return dd.startsWith(typedDomain) || typedDomain.startsWith(dd);
      });
      if (allowedDomains.length > 0 && !typedMatchesAny) {
        setSearchResults([]);
        return;
      }

      await axios
        .get("rajkumar/GetClient?Email=" + d.toString() + "")
        .then(function (response) {
          if (allowedDomains.length > 0) {
            var filtered = response.data.filter(function (item) {
              var emailText = (item.text || "").toLowerCase();
              return allowedDomains.some(function (dd) { return emailText.includes("@" + dd); });
            });
            setSearchResults(filtered);
          } else {
            setSearchResults([]);
          }
        })
        .catch(function (error) {
          alert(error);
        })
        .then(function () {
          // always executed
        });
    }
  }

  async function ClientExistOrNot(ClientId) {
    try {
      let { data } = await axios.get(
        "rajkumar/ClientExistsOrNot?Type=9&ClientId=" + ClientId + ""
      );
      if (data.length > 0) {
        Set_ClientExistOrNot({ setclientexistornot: true });
      }
      // else {
      //   Set_ClientExistOrNot({ setclientexistornot: false });
      //}
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  async function ApprovalCodeToAddRegCorp(ApprovalCode, CCE) {
    try {
      let { data } = await axios.get(
        "rajkumar/ApprovalCodeToAddRegCorp?Type=12&ApprovalCode=" +
        ApprovalCode +
        "&CCE=" +
        CCE +
        ""
      );
      if (data.length > 0) {
        setOpenAddCorporate(true);
        Set_OpenApproval(false);
      }
      // else {
      //   Set_ClientExistOrNot({ setclientexistornot: false });
      //}
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }

  // async function sendMailForReserve(
  //   _uname,
  //   // _upass,
  //   _to,
  //   _cc,
  //   _bcc,
  //   _subject,
  //   _html
  // ) {
  //   console.log(_html);
  //   try {
  //         await axios.post(
  //           "rajkumar/sendemail?_uname=" +
  //           _uname +
  //           // "&_upass=" +
  //           // _upass +
  //           "&_to=" +
  //           _to +
  //           "&_cc=" +
  //           _cc +
  //           "&_bcc=" +
  //           _bcc +
  //           "&_subject=" +
  //           _subject +
  //           "&_html=" +
  //           _html +
  //           ""
  //         )
  //     //alert("mail sent");
  //   } catch (er) {
  //     console.log("error");
  //   }
  // }

  // Returns true if the claim actually went through. Proc_RCB Type=20 enforces the
  // same corporate-count limit as the Add path (Type=13) and returns the same Output
  // strings; anything other than a plain success means no ownership row was written.
  // An empty response is treated as success so this keeps working if the SP has not
  // been patched yet.
  async function transferCorporate(corporateid, userid) {
    set_loading(true);
    try {
      let { data } = await axios.get(
        "rajkumar/TransferCorporateRCB?CceId=" + userid + "&Url=" + corporateid + "&Type=20" + ""
      );
      let outcome = data && data[0] ? data[0].Output : "";
      if (outcome == 'Below Median NR') {
        alert("You can not claim more than 20 corporate as your average NR per regular corporate is less than 10 Lacs.");
        set_loading(false);
        return false;
      }
      if (outcome == 'More Than 40') {
        alert(data[0].Output2);
        set_loading(false);
        return false;
      }
      if (outcome == 'More Than Fifty') {
        alert("You can not claim more than 50 corporate");
        set_loading(false);
        return false;
      }
      get_data(2, 0, "", 0, "", 0, 0, 0, 12, 0, 0, 0, 0);
      set_loading(false);
      return true;
    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
      return false;
    }
  }

  async function sendMailForReserve(uname, to, cc, bcc, subject, html) {
    console.log(cc)
    try {
      var obj = {
        _uname: uname,
        _to: to,
        _cc: cc,
        _bcc: bcc,
        _subject: subject,
        _html: html
      };
      console.log(obj);
      let { data } = await axios.post("Nishant/sendemail", obj);
      if (data != null) {
        NotificationManager.success("Mail sent successfully");
        set_loading(false);
      }
    } catch (er) {
      //alert(JSON.stringify(er));
      set_loading(false);
    }
  }


  async function IsManager(UserId1, UserId) {
    try {
      debugger;
      let { data } =
        await axios.get(
          "rajkumar/ManagerOrNot?Type=17&UserId1=" + UserId1 + "&UserId=" + UserId + ""
        )
      // .then(()=>{
      debugger;
      if (data.length > 0) {
        ismanager.ismanager = true;
        //alert("helo1")
        //alert(data.length);
      }
      else {
        ismanager.ismanager = false;
      }
      // }).catch((er)=>{
      //     alert(JSON.stringify(er));
      //     set_loading(false);
      //   })


    } catch (er) {
      alert(JSON.stringify(er));
      set_loading(false);
    }
  }


  const handleTextAreaReserve = (e) => {
    txtAreaReserve(e.target.value);
    setUrl(url);
  };

  const handleSensitiveReason = (e) => {
    setSensitiveReason(e.target.value);
  }

  const handleInputURL = (e) => {
    setUrl(e.target.value);
  };

  const handleInputApprovalCode = (e) => {
    setApprovalCode(e.target.value);
  };

  const handleInputDeleteClick = (e) => {
    set_ClientName("");
    set_show_list("none");
    setSearchResults([]);
  };

  const handleInputCommonName = (e) => {
    set_CommonName(e.target.value);
  };

  const handleInputUrl = (e) => {
    setUrl(e.target.value);
  }
  const handleInputPotential = (e) => {
    set_PotentialRevenu(e.target.value);
  };
  const handleInputNoofEmployee = (e) => {
    set_NoofEmp(e.target.value);
  };

  const handleInputVendorCode = (e) => {
    set_VendorCode(e.target.value);
  }

  const handleFindAdditionalContacts = async (corporateName, corporateId, rowUserId, country) => {
    const currentUserId = userid.toString();
    const rowUserIdStr = rowUserId ? rowUserId.toString() : '';

    if (currentUserId !== rowUserIdStr) {
      alert("Not your corporate");
      return;
    }
    try {
      set_loading(true);
      const [dbContacts, prospects] = await Promise.all([
        fetchContactsFromDB(corporateId),
        fetchApolloProspects(corporateName.replace(/\s+/g, ''), country)
      ]);
      ViewAdditionalContacts(prospects, dbContacts, corporateId, currentUserId);
    } catch (error) {
      alert("Something went wrong!!");
    } finally {
      set_loading(false);
    }
  }


  const fetchContactsFromDB = async (corporateId) => {
    try {
      const { data } = await axios.get(`rajkumar/GetAdditionalContacts?corporateId=${encodeURIComponent(corporateId)}`);
      return data || [];
    } catch (error) {
      console.log('DB fetch failed:', error);
      return [];
    }
  }

  const fetchApolloProspects = async (corporateName, country) => {
    try {
      const { data } = await axios.get(`rajkumar/GetApolloProspects?corporateName=${encodeURIComponent(corporateName)}&country=${encodeURIComponent(country || '')}`);
      return data || [];
    } catch (error) {
      console.error('Apollo prospects fetch failed:', error);
      return [];
    }
  }


  const ViewAdditionalContacts = (prospects, initialDbContacts, corporateId, userId) => {
    const AdditionalContactsModal = () => {
      const [selectedIds, setSelectedIds] = React.useState(new Set());
      const [phoneIds, setPhoneIds] = React.useState(new Set());
      const [dbContacts, setDbContacts] = React.useState(initialDbContacts || []);
      const [messages, setMessages] = React.useState({});
      const [processing, setProcessing] = React.useState(false);
      const [phoneWarning, setPhoneWarning] = React.useState(false);

      const handleCheckbox = (id) => {
        setSelectedIds(prev => {
          const next = new Set(prev);
          if (next.has(id)) {
            next.delete(id);
            setPhoneIds(function (prevPh) { var np = new Set(prevPh); np.delete(id); return np; });
          } else {
            if (next.size < 5) next.add(id);
          }
          return next;
        });
      };

      const handlePhoneCheckbox = (id) => {
        setPhoneIds(prev => {
          const next = new Set(prev);
          if (next.has(id)) next.delete(id);
          else next.add(id);
          return next;
        });
      };

      const handleOk = async () => {
        if (selectedIds.size === 0) return;
        setProcessing(true);
        const newMessages = {};
        const newContacts = [];

        var anyPhoneRequested = false;
        for (const prospectId of selectedIds) {
          try {
            var revealPhone = phoneIds.has(prospectId);
            if (revealPhone) anyPhoneRequested = true;
            const { data } = await axios.post('rajkumar/EnrichAndSaveContact', { prospectId, userId, corporateId, revealPhone });
            if (data.status === 'exists') {
              newMessages[prospectId] = 'Already in contacts';
            } else if (data.status === 'saved') {
              newMessages[prospectId] = 'Saved!';
              newContacts.push(data.contact);
            }
          } catch (err) {
            newMessages[prospectId] = 'Error';
          }
        }

        // Merge messages so previous Saved!/Already results are preserved
        setMessages(prev => (Object.assign({}, prev, newMessages)));
        if (newContacts.length > 0) {
          setDbContacts(prev => [...newContacts, ...prev]);
        }
        setSelectedIds(new Set());
        if (anyPhoneRequested) setPhoneWarning(true);
        setProcessing(false);
      };

      return (
        <SweetAlert
          title="Additional Contacts"
          customClass="sweetAlertWidth70"
          showCloseButton={true}
          showConfirm={false}
          onCancel={() => hideAlert()}
        >
          <div style={{ marginTop: '10px' }}>

            {/* Section 1 — Apollo Prospects */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
              <strong>Apollo Prospects</strong>
              <span style={{ fontSize: '12px', color: '#888' }}>Max 5 can be selected at a time | <span style={{ color: '#d9534f' }}>Selecting Ph No will cost INR 100 per contact</span></span>
            </div>
            <hr style={{ borderTop: '1px solid #d3d3d3', margin: '0 0 6px 0' }} />
            {prospects.length === 0 ? (
              <div style={{ fontSize: '15px', textAlign: 'center', padding: '10px', color: '#888' }}>No prospects found</div>
            ) : (
              <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                <table className="table table-bordered" style={{ textAlign: 'left', marginBottom: '0' }}>
                  <thead style={{ backgroundColor: 'rgba(222, 226, 230, 0.5)' }}>
                    <tr>
                      <th style={{ width: '36px' }}></th>
                      <th>Name</th>
                      <th>Title</th>
                      <th>Organization</th>
                      <th>Seniority</th>
                      <th style={{ width: '50px' }}>Ph No</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prospects.map(p => (
                      <tr key={p.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedIds.has(p.id)}
                            disabled={processing || messages[p.id] === 'Saved!' || messages[p.id] === 'Already in contacts' || (!selectedIds.has(p.id) && selectedIds.size >= 5)}
                            onChange={() => handleCheckbox(p.id)}
                          />
                        </td>
                        <td>{p.first_name} {p.last_name_obfuscated}</td>
                        <td>{p.title}</td>
                        <td>{(p.organization && p.organization.name) || ''}</td>
                        <td>{p.seniority}</td>
                        <td style={{ textAlign: 'center' }}>
                          <input
                            type="checkbox"
                            checked={phoneIds.has(p.id)}
                            disabled={!selectedIds.has(p.id) || processing || messages[p.id] === 'Saved!' || messages[p.id] === 'Already in contacts'}
                            onChange={function () { handlePhoneCheckbox(p.id); }}
                          />
                        </td>
                        <td style={{ fontSize: '12px', color: messages[p.id] === 'Saved!' ? 'green' : messages[p.id] === 'Already in contacts' ? 'orange' : 'red' }}>
                          {messages[p.id] || ''}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ textAlign: 'right', margin: '8px 0' }}>
              <button className="btn btn-primary btn-sm" onClick={handleOk} disabled={processing || selectedIds.size === 0}>
                {processing ? 'Processing...' : 'OK'}
              </button>
            </div>
            {phoneWarning && (
              <div style={{ padding: '6px 10px', marginBottom: '6px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', fontSize: '12px', color: '#856404' }}>
                Private number may take 2-3 minutes to appear. Please close and reopen this dialog to see updated phone numbers.
              </div>
            )}

            {/* Divider */}
            <hr style={{ borderTop: '2px solid #d3d3d3', margin: '4px 0 10px 0' }} />

            {/* Section 2 — Saved Contacts */}
            <strong>Saved Contacts</strong>
            <hr style={{ borderTop: '1px solid #d3d3d3', margin: '6px 0' }} />
            {dbContacts.length === 0 ? (
              <div style={{ fontSize: '15px', textAlign: 'center', padding: '10px', color: '#888' }}>No saved contacts yet</div>
            ) : (
              <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                <table className="table table-bordered" style={{ textAlign: 'left', marginBottom: '0' }}>
                  <thead style={{ backgroundColor: 'rgba(222, 226, 230, 0.5)' }}>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Private No</th>
                      <th>Department</th>
                      <th>LinkedIn</th>
                      <th>Head Count</th>
                      <th>Email ID Type</th>
                      <th>Company Type</th>
                      <th>Lead Form</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dbContacts.map((contact, index) => (
                      <tr key={index}>
                        <td>{contact.Name || '-'}</td>
                        <td>{contact.Email || ''}</td>
                        <td>{contact.PhoneNumber || ''}</td>
                        <td>{contact.PrivateNumber || ''}</td>
                        <td>{contact.Department || ''}</td>
                        <td>{contact.LinkedIn || ''}</td>
                        <td>{contact.Headcount || ''}</td>
                        <td>{contact.EmailType || ''}</td>
                        <td>{contact.CompanyType || ''}</td>
                        <td>
                          <a href={`https://rms.koenig-solutions.com/LSF/Leadsub-form.aspx?RCBID=${contact.Id}`} target="_blank" rel="noopener noreferrer">
                            Open
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

          </div>
        </SweetAlert>
      );
    };

    ReactDOM.render(<AdditionalContactsModal />, document.getElementById('getSweetModel'));
  };

  const edit = (data) => {
    debugger;
    set_source(null);
    set_ClientName("");
    setSearchResults([]);
    setUrl(data.URL);
    originalUrlRef.current = data.URL;
    set_IndustryId(data.IndustryId);
    set_CountryId(data.CountryId);
    set_CCEId(data.UserId);
    set_CommonName(data.CorporateName);
    set_Empanel({ empanel: data.Empaneled });
    set_Marquee({ marquee: data.Marquee });
    getClientsForRC("7", data.CorporateID, userid);
    setFile(data.RCLogo);
    set_UrlId(data.CorporateID);
    Set_ClientExistOrNot({ setclientexistornot: false });
    getDownloadPP(data.RCLogo);
    set_PotentialRevenu(data.PotentialRevenue);
    set_NoofEmp(data.NoofEmployee);
    set_VendorCode(data.VendorCode);
    setSecondUrl(data.SecondURL || "");
    setSecondUrlReason(data.SecondURLReason || "");
    // Multi-domain: pull the full list (legacy SecondURL folded in until first save).
    loadAdditionalDomainsForUrl(data.CorporateID);
    set_CCE(prev => prev.filter(opt => !opt.temp));
    if (!cce.some(opt => opt.value === data.UserId)) {
      set_CCE(prev => [
        ...prev,
        {
          key: data.UserId,
          value: data.UserId,
          text: data.UserName,
          temp: true
        }
      ]);
    }

    setOpenEditCorporate(true);
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
      padding: theme.spacing(0),
      textAlign: "center",
      backgroundColor: "#313F45",
      color: "#FFF",
      margin: theme.spacing(1),
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    container: {
      width: "100%",
    },
    searchInput: {
      float: "left",
      width: "18rem",
    },
    tablePagination: {
      width: "65rem",
    },
    divStyle: {
      float: "left",
      width: "32vw",
      margin: "20px",
    },
    tableCell: {
      display: "inline-flex",
    },
    pageWrapper: {
      width: "100%",
      maxWidth: "98vw",
      margin: "0 auto",
      padding: "20px 24px 20px 24px",
      fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
      background: "#f4f6f9",
      minHeight: "100vh",
    },
    headerBanner: {
      background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
      borderRadius: "10px",
      padding: "18px 28px",
      marginBottom: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "16px",
      boxShadow: "0 2px 12px rgba(30,41,59,0.18)",
      border: "none",
    },
    headerTitle: {
      color: "#fff",
      fontSize: "1.35rem",
      fontWeight: 700,
      letterSpacing: "-0.2px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    headerTitleIcon: {
      background: "rgba(255,255,255,0.15)",
      borderRadius: "8px",
      padding: "8px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
    headerActions: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
      alignItems: "center",
    },
    actionBtn: {
      borderRadius: "7px !important",
      fontWeight: "600 !important",
      textTransform: "none !important",
      padding: "7px 16px !important",
      fontSize: "12.5px !important",
      transition: "all 0.15s ease !important",
      boxShadow: "none !important",
      border: "1px solid transparent !important",
      letterSpacing: "0.1px",
      fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif !important",
    },
    statsBar: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      fontSize: "0.82rem",
    },
    statsBadge: {
      background: "rgba(255,255,255,0.12)",
      borderRadius: "20px",
      padding: "4px 14px",
      fontSize: "0.78rem",
      fontWeight: 600,
      color: "rgba(255,255,255,0.85)",
      border: "1px solid rgba(255,255,255,0.18)",
    },
    filterCard: {
      background: "#fff",
      borderRadius: "10px",
      padding: "18px 24px 12px 24px",
      marginBottom: "16px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      border: "1px solid #e2e8f0",
    },
    filterTitle: {
      fontSize: "11px",
      fontWeight: 700,
      color: "#64748b",
      textTransform: "uppercase",
      letterSpacing: "1.2px",
      marginBottom: "14px",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      paddingBottom: "10px",
      borderBottom: "1px solid #f1f5f9",
    },
    infoTip: {
      background: "#fffbeb",
      borderLeft: "3px solid #f59e0b",
      borderRadius: "0 8px 8px 0",
      padding: "10px 16px",
      marginBottom: "8px",
      fontSize: "12.5px",
      color: "#78350f",
      lineHeight: 1.6,
      fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
    },
    searchBarWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "12px",
    },
  }));

  const classes = useStyles();
  // class="ui raised segment"
  return (

    <div>
      {/* ===== LOADER ===== */}
      <div
        style={{
          display: loading ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          flexDirection: "column",
          height: "80vh",
          background: "#f4f6f9",
        }}
      >
        <Loader active inline size="large" style={{ marginBottom: "12px" }} />
        <span style={{ color: "#64748b", fontSize: "14px", fontWeight: 500, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
          Loading data...
        </span>
      </div>
      <div id="getSweetModel"></div>

      <div style={{ display: loading ? "none" : "flex" }}>
        <div className={classes.pageWrapper}>
          {/* ===== HEADER BANNER ===== */}
          <div className={classes.headerBanner}>
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div className={classes.headerTitle}>
                <span className={classes.headerTitleIcon}>
                  <Icon name="building" style={{ color: "#fff", margin: 0, fontSize: "1.1rem" }} />
                </span>
                Regular Corporate Business
              </div>
              <div className={classes.statsBar}>
                <span className={classes.statsBadge}>
                  {data_list.length} Records
                </span>
              </div>
            </div>
            <div className={classes.headerActions}>
              <Button
                className={`${classes.actionBtn} rcb-header-btn`}
                onClick={() => {
                  set_ClientName("");
                  setSearchResults([]);
                  setSecondUrl("");
                  setSecondUrlReason("");
                  userid.toString() === "188" ||
                    userid.toString() === "221" ||
                    userid.toString() === "4562"
                    ? setOpenAddCorporate(true)
                    : setOpenAddCorporate(true)
                }}
                size="mini"
                style={{ background: "#fff", color: "#1e293b", border: "none" }}
              >
                <Icon name="plus circle" style={{ color: "#1e293b", margin: "0 6px 0 0" }} />
                Add Corporate
              </Button>
              <Button
                className={`${classes.actionBtn} rcb-header-btn`}
                onClick={() => { get_FAQ(); }}
                size="mini"
                style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}
              >
                <Icon name="question circle outline" style={{ margin: "0 5px 0 0" }} />
                FAQ
              </Button>
              <Button
                className={`${classes.actionBtn} rcb-header-btn`}
                onClick={() => { get_Excel(); }}
                size="mini"
                style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}
              >
                <Icon name="file excel outline" style={{ margin: "0 5px 0 0" }} />
                Export Excel
              </Button>
              <Button
                className={`${classes.actionBtn} rcb-header-btn`}
                onClick={() => { get_ExcelPPC(); }}
                size="mini"
                style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}
              >
                <Icon name="file excel outline" style={{ margin: "0 5px 0 0" }} />
                Excel (PPC)
              </Button>
              <Button
                className={`${classes.actionBtn} rcb-header-btn`}
                onClick={() => { get_MedianData(); }}
                size="mini"
                style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}
              >
                <Icon name="chart bar" style={{ margin: "0 5px 0 0" }} />
                Median Data
              </Button>
            </div>
          </div>
          {/* ===== MODALS SECTION ===== */}
          <span>
            <Modal
              size="mini"
              open={openapproval}
              onClose={() => Set_OpenApproval(false)}
              closeIcon={<Icon color="red" name="window close" />}
              style={{
                height: "28vh",
                width: "35vw",
                marginTop: "20vh",
                marginLeft: "60vh",
              }}
            >
              <Modal.Header>Approval code to add corporate</Modal.Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  <div style={{ height: "10vh", maxWidth: "15vw" }}>
                    <div
                      className={classes.divStyle}
                      style={{ marginBottom: "0px" }}
                    >
                      <Input
                        placeholder="Enter approval code"
                        style={{ width: "30vw" }}
                        onChange={handleInputApprovalCode}
                      />
                    </div>
                    <div className={classes.divStyle}>
                      <Button
                        icon
                        labelPosition="right"
                        floated="right"
                        size="mini"
                        style={{ marginRight: "3em" }}
                        onClick={() => {
                          if (
                            approval_code === null ||
                            approval_code === ""
                          ) {
                            alert("Approval code should not be blank");
                            return;
                          }
                          ApprovalCodeToAddRegCorp(approval_code, userid);
                        }}
                      >
                        Apply
                        <Icon name="save" />
                      </Button>
                    </div>
                  </div>
                </Modal.Description>
              </Modal.Content>
            </Modal>
            <Modal
              open={openaddcorporate}
              onClose={() => {
                setOpenAddCorporate(false);

                setUrl("");
                set_IndustryId(0);
                set_Empanel(0);
                set_CountryId(0);
                set_Marquee(0);
                setFile("");
                set_CommonName("");
                TempClient([]);
                set_CCEId(0);
                setOpenAddCorporate(false);
                Set_ClientExistOrNot({ setclientexistornot: false });
              }}
              //onOpen={() => {setOpenAddCorporate(true)}}
              closeIcon={<Icon color="red" name="window close" />}
            // trigger={<Button icon="add" label="Add regular corporate" />}
            >
              <Modal.Header>Add Corporate</Modal.Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  <div style={{ height: "70vh", maxWidth: "75vw" }}>
                    <div
                      className={classes.divStyle}
                      style={{ marginBottom: "0px" }}
                    >
                      <Input
                        placeholder="Domain of RC URL"
                        style={{ width: "30vw" }}
                        onChange={handleInputURL}
                      />
                      <div style={{ color: "red", fontSize: "12px" }}>* Only Domain of RC to be added not the complete URL. eg. @XXXX.com</div>
                    </div>
                    <div
                      className={classes.divStyle}
                      style={{ marginBottom: "0px" }}
                    >
                      <div style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                        <b style={{ fontSize: "13px" }}>Additional Domains (Optional)</b>
                        <Button
                          size="mini"
                          primary
                          disabled={!url}
                          onClick={addDomainRow}
                          style={{ marginLeft: "10px" }}
                        >
                          <Icon name="plus" /> Add Domain
                        </Button>
                      </div>
                      {additionalDomains.map((d, idx) => (
                        <div key={idx} style={{ marginBottom: "10px", padding: "8px", border: "1px solid #e5e7eb", borderRadius: "6px" }}>
                          <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                            <Input
                              placeholder="Enter Additional Domain (e.g. @company.com)"
                              style={{ width: "26vw" }}
                              value={d.Domain}
                              onChange={(e) => updateDomainField(idx, "Domain", e.target.value)}
                            />
                            <Button
                              size="mini"
                              negative
                              icon
                              onClick={() => removeDomainRow(idx)}
                              style={{ marginLeft: "8px" }}
                              title="Remove this domain"
                            >
                              <Icon name="trash" />
                            </Button>
                          </div>
                          <div style={{ color: "red", fontSize: "11px", marginBottom: "3px" }}>* Bonafide reason for this additional domain</div>
                          <Input
                            placeholder="Reason (e.g. Acquired subsidiary uses this domain)"
                            style={{ width: "30vw" }}
                            value={d.Reason}
                            onChange={(e) => updateDomainField(idx, "Reason", e.target.value)}
                          />
                        </div>
                      ))}
                    </div>
                    <div className={classes.divStyle}>
                      <IndustryDropDown
                        scrolling
                        passChildData={(industryId) => {
                          set_IndustryId(industryId);
                        }}
                      />
                    </div>
                    <div className={classes.divStyle}>
                      <CCEList
                        scrolling
                        type={7}
                        passChildData={(cceid) => {
                          set_CCEId(cceid);
                        }}
                      />
                    </div>
                    <div className={classes.divStyle}>
                      <CountryDropDown
                        scrolling
                        passChildData={(countryname, countryId) => {
                          set_CountryId(countryId);
                          set_CountryName(countryname);
                        }}
                      />
                    </div>
                    <div
                      className={classes.divStyle}
                      style={{ width: "20vw" }}
                    >
                      <label>Logo : </label>
                      <Button onClick={handleUpload} size="mini">
                        <Icon color="teal" name="upload" />
                      </Button>
                      <input
                        id="saveFilercbLogo"
                        type="file"
                        style={{ marginLeft: "1em" }}
                        onChange={(e) => {
                          handleChangelogo(e);
                        }}
                        ref={fileInput}
                      />
                    </div>
                    <div
                      className={classes.divStyle}
                      style={{
                        width: "10vw",
                        height: "10vh",
                        marginBottom: "0vh",
                      }}
                      onClick={() => handleRemove()}
                    >
                      {/* {getDownloadPP(file.name?file.name:file)} */}
                      {/* (file !== null &&
                                          file !== "undefined" &&
                                          file !== ""
                                          ? file.name
                                          : "") */}

                      {file && source && (
                        <img
                          id="updateImgrcbLogo"
                          src={source ? source : null}
                          alt={file ? file : null}
                          style={{
                            transform: "scale(5)!important",
                          }}
                        // onClick={onclick}
                        />
                      )}
                      {/* {file && (
                          <img id="saveImgrcbLogo" src={file} alt={file.name} />
                        )} */}
                    </div>

                    <div
                      className={classes.divStyle}
                      style={{ marginTop: "-10px", marginBottom: "0px" }}
                    >
                      <label>Common Name</label>
                      <Input
                        style={{ width: "30vw" }}
                        onChange={handleInputCommonName}
                      />
                    </div>

                    <div
                      className={classes.divStyle}
                      style={{ marginBottom: "0px" }}
                    >
                      <label>Potential Revenue</label>
                      <Input style={{ width: "30vw" }}
                        onChange={handleInputPotential} />
                    </div>
                    <div className={classes.divStyle}>
                      <label># of Employee</label>
                      <Input style={{ width: "30vw" }}
                        onChange={handleInputNoofEmployee
                        } />
                    </div>
                    <div
                      className={classes.divStyle}
                    >
                      <label>Vendor Code</label>
                      <Input
                        style={{ width: "30vw" }}
                        onChange={handleInputVendorCode}

                      />

                    </div>

                    <div
                      class="custom-control custom-checkbox custom-control-inline"
                      className={classes.divStyle}
                    >
                      <div
                        style={{ visibility: "hidden" }}
                        class="custom-control custom-checkbox custom-control-inline"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="addforRevival"
                        />
                        <label
                          class="custom-control-label"
                          for="addforRevival"
                        >
                          For Revival
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="addmarquee"
                          onChange={() => {
                            set_Marquee({ marquee: !marquee.marquee });
                          }}
                        />
                        <label class="custom-control-label" for="addmarquee">
                          Marquee
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="addEmpanelment"
                          onChange={() => {
                            set_Empanel({ empanel: !empanel.empanel });
                          }}
                        />
                        <label
                          class="custom-control-label"
                          for="addEmpanelment"
                        >
                          Empanelment done
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="addNotEmpanelment"
                        />
                        <label
                          class="custom-control-label"
                          for="addNotEmpanelment"
                        >
                          Empanelment not required
                        </label>
                      </div>
                    </div>
                    <div className={classes.divStyle}>
                      <div style={{ color: "red", fontSize: "12px", marginBottom: "5px" }}>* Only Client Email IDs with the same domain as the RC Domain can be added.<br />* Type at least 3 characters after @ to get the dropdown options for selecting the Email ID.</div>
                      <div style={{ margin: 10 }}>
                        <div className="divSearchBoxDesktop">
                          <div className="divSearchBarDesktop">
                            <span className="SearchBarDesktop">
                              <Input
                                onChange={(t) => {
                                  search(t.target.value);
                                  set_ClientName(t.target.value);
                                }}
                                value={clientname}
                                //className="inputSearchDesktop"
                                style={{ width: "500px" }}
                                placeholder="Enter Contacts"
                                icon={
                                  <Icon
                                    name="delete"
                                    link
                                    onClick={handleInputDeleteClick}
                                  />
                                }
                              />
                            </span>
                            <span className="SearchBoxItemDesktop">
                              {searchResults.map((item) => {
                                return (
                                  <span
                                    type="button"
                                    key={item.value}
                                    onClick={(e) => {
                                      set_ClientId(item.key);
                                      // set_ClientName(e.target.innerText);
                                      //ClientExistOrNot(item.value);
                                      // if (
                                      //   setclientexistornot.setclientexistornot ===
                                      //   true
                                      // ) {
                                      //   alert(
                                      //     "this client linked with another corporate"
                                      //   );
                                      //   return;
                                      // }

                                      //ddd[0].URL

                                      const newList = tempclient.concat({
                                        name: item.text,
                                        id: item.value,
                                      });

                                      const newList1 = newList.filter(
                                        (x, i) => x.name !== ""
                                      );

                                      let mymap = new Map();

                                      const newList2 = newList1.filter(
                                        (el) => {
                                          const val = mymap.get(el.name);

                                          if (val) {
                                            if (el.id < val) {
                                              mymap.delete(el.name);
                                              mymap.set(el.name, el.id);
                                              return true;
                                            } else {
                                              return false;
                                            }
                                          }
                                          mymap.set(el.name, el.id);
                                          return true;
                                        }
                                      );

                                      TempClient(newList2);

                                      // set_ClientId(0);
                                      // set_ClientName("");
                                      set_show_list("none");
                                      setSearchResults([]);
                                    }}
                                    className="listSearchDesktop"
                                  >
                                    {item.text}
                                  </span>
                                );
                              })}
                            </span>
                            <div className="divSelectNumberDesktop"></div>
                          </div>
                        </div>
                      </div>

                      {/* <ClientDropDown
                          scrolling
                          passChildData={(clientname, clientid) => {
                            set_ClientId(clientid);
                            set_ClientName(clientname);

                            const newList = tempclient.concat({
                              name: clientname,
                              id: clientid,
                            });

                            const newList1 = newList.filter(
                              (x, i) => x.name !== ""
                            );

                            let mymap = new Map();

                            const newList2 = newList1.filter((el) => {
                              const val = mymap.get(el.name);

                              if (val) {
                                if (el.id < val) {
                                  mymap.delete(el.name);
                                  mymap.set(el.name, el.id);
                                  return true;
                                } else {
                                  return false;
                                }
                              }
                              mymap.set(el.name, el.id);
                              return true;
                            });

                            TempClient(newList2);

                            set_ClientId(0);
                            set_ClientName("");
                          }}
                        /> */}
                      <Table
                        id="PopUpTempClients"
                        className="table table-bordered table-responsive table-striped"
                        size="sm"
                        stickyHeader
                      >
                        <URLClientsTableTemp />
                        <TableBody>
                          {tempclient.map((d) => {
                            return (
                              <TableRow hover key={d.id}>
                                <TableCell
                                  component="th"
                                  // id={labelId}
                                  scope="row"
                                  padding="none"
                                  align="center"
                                >
                                  {d.name}
                                </TableCell>
                                <TableCell>
                                  <Button
                                    onClick={() => handleRemovetemp(d.id)}
                                    icon
                                    size="mini"
                                    style={{ marginRight: "3em" }}
                                  >
                                    <Icon name="close icon" />
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                    <div className={classes.divStyle}>
                      <Button
                        icon
                        labelPosition="right"
                        floated="right"
                        size="huge"
                        style={{ marginRight: "3em" }}
                        onClick={async () => {
                          if (url === null || url === "") {
                            alert("URL should not be blank");
                            return;
                          }

                          if (
                            (file !== null &&
                              file !== "undefined" &&
                              file !== "") &&
                            ((!imgupload && imgupload1) || (imgupload && !imgupload1))
                          ) {
                            alert("you should click Upload before save as you have select an image file");
                            return;
                          }

                          //saveRCLogo(file);

                          // set_source(null);

                          if (tempclient.length === 0) {
                            alert("Atleast one client Email / Spoc Email should be included to Map the corporate");
                            return;
                          }

                          // Multi-domain: validate ALL rows (each via AI) before touching the DB.
                          if (additionalDomains.length > 0) {
                            set_loading(true);
                            const aiCheckAll = await validateAllDomainsAI(additionalDomains);
                            set_loading(false);
                            if (!aiCheckAll.valid) { alert(aiCheckAll.message); return; }
                          }

                          let tblSaveRCB = [];

                          let objSaveRCB = {
                            _URLId: 0,
                            _Url: url,
                            _industryId: industryId !== null ? industryId : 0,
                            _empanel: empanel.empanel ? 1 : 0,
                            _countryId: countryId !== null ? countryId : 0,
                            _marquee: marquee.marquee ? 1 : 0,
                            _file:
                              file !== null &&
                                file !== "undefined" &&
                                file !== ""
                                ? file.name
                                : "",
                            _userid: userid !== null ? userid : 0,
                            _commonname:
                              commonname !== null ? commonname : "",
                            _tempclient: JSON.stringify(tempclient),
                            _cceid: cceid !== null ? cceid : 0,
                            _PotentialRevenu: PotentialRevenu !== null ? PotentialRevenu : 0,
                            _NoofEmp: NoofEmp !== null ? NoofEmp : 0,
                            _VendorCode: VenddorCode !== null ? VenddorCode : "",
                            // Multi-domain lives in the new child table. Empty here so Proc_RCB Type=13
                            // doesn't populate the legacy columns.
                            _SecondURL: "",
                            _SecondURLReason: "",
                          };
                          tblSaveRCB.push(objSaveRCB);
                          await save_data(tblSaveRCB);
                          // Persist domains AFTER the corporate save so the backend can resolve
                          // the freshly-created UrlID from (Url + CSMUserId).
                          if (additionalDomains.length > 0) {
                            await persistAdditionalDomains(0, url, cceid !== null ? cceid : 0);
                          }
                          setAdditionalDomains([]);
                          // (
                          //   "5",
                          //   0,
                          //   url,
                          //   industryId !== null ? industryId : 0,
                          //   empanel.empanel ? 1 : 0,
                          //   countryId !== null ? countryId : 0,
                          //   marquee.marquee ? 1 : 0,
                          //   file !== null &&
                          //     file !== "undefined" &&
                          //     file !== ""
                          //     ? file.name
                          //     : "",
                          //   userid !== null ? userid : 0,
                          //   commonname !== null ? commonname : "",
                          //   JSON.stringify(tempclient),
                          //   cceid !== null ? cceid : 0
                          // );
                          // alert("action completed");

                          // set_loading(false);
                          setUrl("");
                          set_IndustryId(0);
                          set_Empanel(0);
                          set_CountryId(0);
                          set_Marquee(0);
                          setFile("");
                          set_CommonName("");
                          TempClient([]);
                          set_CCEId(0);
                          setOpenAddCorporate(false);
                          Set_ClientExistOrNot({
                            setclientexistornot: false,
                          });
                          setImageUpload(false);
                          setImageUpload1(false);
                        }}
                      >
                        Save
                        <Icon name="save" />
                      </Button>
                    </div>
                  </div>
                </Modal.Description>
              </Modal.Content>
            </Modal>

            <Modal
              open={openfaq}
              onClose={() => {
                Set_OpenFAQ(false);
              }}
              closeIcon={<Icon color="red" name="window close" />}
            >
              <Modal.Header>FAQ</Modal.Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  <div style={{ height: "70vh", maxWidth: "75vw" }}>
                    <div dangerouslySetInnerHTML={{ __html: faq }} />
                  </div>
                </Modal.Description>
              </Modal.Content>
            </Modal>

            <Modal
              open={MedianData}
              onClose={() => {
                Set_OpenMedianData(false);
              }}
              closeIcon={<Icon color="red" name="window close" />}
            >
              <Modal.Header>Corporate Median Data</Modal.Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  <TableContainer
                    component={Paper}
                  // className={classes.container}
                  >
                    <Table
                      id="MedianData"
                      className="table table-bordered table-responsive table-striped"
                      size="sm"
                      stickyHeader
                    >
                      <MedianTable />
                      <TableBody>
                        {modalMedianData.map((d) => {
                          return (
                            <TableRow key={d.id} hover>
                              <TableCell
                                component="th"
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {d.CCECode}
                              </TableCell>
                              <TableCell
                                component="th"
                                // id={labelId}
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {d.CCE}
                              </TableCell>
                              <TableCell
                                component="th"
                                // id={labelId}
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {d.Manager}
                              </TableCell>
                              <TableCell
                                component="th"
                                // id={labelId}
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {d.No_Of_Corporate}
                              </TableCell>
                              <TableCell
                                component="th"
                                // id={labelId}
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {d.TotalRegCorpNR}
                              </TableCell>
                              <TableCell
                                component="th"
                                // id={labelId}
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {<div dangerouslySetInnerHTML={{ __html: d.AverageNR_perRegularCorporate }} />}
                              </TableCell>
                              <TableCell
                                component="th"
                                // id={labelId}
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {d.MedianNR}
                              </TableCell>
                            </TableRow>
                          );
                        })}

                        {modalMedianData.length === 0 && (
                          <TableRow>
                            {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                            <TableCell
                              colSpan={4}
                              component="th"
                              scope="row"
                              padding="none"
                              textAlign="center"
                              style={{ fontSize: "2rem" }}
                            >
                              No data
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Modal.Description>
              </Modal.Content>
            </Modal>


          </span>

          {/* ===== FILTER SECTION ===== */}
          <div className={classes.filterCard}>
            <div className={classes.filterTitle}>
              <Icon name="sliders horizontal" style={{ color: "#94a3b8", fontSize: "12px" }} />
              Filters
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "flex-end" }} className="row">
              <span
                style={{
                  fontSize: 12,
                  fontWeight: "bolder",
                  marginTop: 10,
                  display: "none",
                }}
              >
                <br />
                <Checkbox
                  color="primary"
                  checked={forrevival.forrevival}
                  onChange={() => {
                    set_ForRevival({ forrevival: !forrevival.forrevival });
                  }}
                />
                Under Revival
              </span>


              <span
                style={{
                  fontSize: 12,
                  fontWeight: "bolder",
                  margin: 10,
                  display: "none",
                }}
              >
                <br />
                <Checkbox
                  color="primary"
                  checked={freedomain.freedomain}
                  onChange={() => {
                    freeDomain({ freedomain: !freedomain.freedomain });
                  }}
                // onChange={() => {
                //   set_loading(true);
                //   get_data(
                //     2,
                //     cceid,
                //     "",
                //     withoutcce.withoutcce ? 1 : 0,
                //     "",
                //     countryId,
                //     !freedomain.freedomain ? 1 : 0
                //   );
                //   freeDomain({ freedomain: !freedomain.freedomain });
                // }}
                />
                Only free domain
              </span>

              <div style={{ fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <div>
                  <CountryDropDown
                    scrolling
                    passChildData={(countryname, countryId) => {
                      set_CountryId(countryId);
                      set_CountryName(countryname);
                      setSelectedCountryId(countryId);
                    }}
                    selectedValue={selectedCountryId}
                  />
                </div>
              </div>

              <div style={{ fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <div>
                  <CCEList
                    scrolling
                    type={7}
                    passChildData={(cceid) => {
                      set_CCEId(cceid);
                    }}
                  />
                </div>
              </div>

              <div style={{ fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <div>
                  <SalesManagerDDL
                    scrolling
                    passChildData={(managerid) => {
                      set_MANAGERId(managerid);
                    }}
                  />
                </div>
              </div>

              <div style={{ fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <div>
                  <TextField
                    variant="outlined"
                    label="NR more than"
                    placeholder="0"
                    fullWidth
                    onChange={(e) => {
                      set_NR({
                        nr: e.target.value === "" ? 0 : parseInt(e.target.value),
                      });
                    }}
                    InputLabelProps={{
                      shrink: true,
                      style: {
                        padding: '1.5px 8px', // Set padding here
                      }
                    }}
                  >
                    <InputLabel style={{ padding: '1.5px 8px' }} shrink htmlFor="nrl-more-than">
                      NR more than
                    </InputLabel>
                  </TextField>
                  {/* NR more than
                <br />
                <Input
                  placeholder="0"
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    set_NR({
                      nr: e.target.value === "" ? 0 : parseInt(e.target.value),
                    });
                  }}
                /> */}
                </div>
              </div>

              <div style={{ fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <div>
                  <TextField
                    variant="outlined"
                    label="NR less than"
                    placeholder="0"
                    fullWidth
                    onChange={(e) => {
                      set_NRLess({
                        nrLess: e.target.value === "" ? 0 : parseInt(e.target.value),
                      });
                    }}
                    InputLabelProps={{
                      shrink: true,
                      style: {
                        padding: '1.5px 8px', // Set padding here
                      }
                    }}
                  >
                    <InputLabel style={{ padding: '1.5px 8px' }} shrink htmlFor="nrl-less-than">
                      NR less than
                    </InputLabel>
                  </TextField>
                </div>
              </div>

              <div style={{ fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <div>
                  <TextField
                    variant="outlined"
                    label="Last Months"
                    placeholder="12"
                    fullWidth
                    onChange={(e) => {
                      set_Month({
                        month:
                          e.target.value === "" ? 12 : parseInt(e.target.value),
                      });
                    }}
                    InputLabelProps={{
                      shrink: true,
                      style: {
                        padding: '1.5px 8px', // Set padding here
                      }
                    }}
                  >
                    <InputLabel style={{ padding: '1.5px 8px' }} shrink htmlFor="nrl-months">
                      Last Months
                    </InputLabel>
                  </TextField>
                  {/* Last Months
                <br />
                <Input
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    set_Month({
                      month:
                        e.target.value === "" ? 12 : parseInt(e.target.value),
                    });
                  }}
                  placeholder="12"
                /> */}
                  {/* <b>Months</b> */}
                </div>
              </div>

              <div style={{ fontSize: 10, fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <Checkbox
                  color="primary"
                  checked={withoutcce.withoutcce}
                  onChange={() => {
                    withOutCCE({ withoutcce: !withoutcce.withoutcce });
                  }}
                />
                W/O any CCE
              </div>

              <div style={{ fontSize: 10, fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <Checkbox
                  color="primary"
                  checked={corporatescbutnotregularcorporate.corporatescbutnotregularcorporate}
                  onChange={() => {
                    CorporateScButNotRegularCorporate({ corporatescbutnotregularcorporate: !corporatescbutnotregularcorporate.corporatescbutnotregularcorporate });
                  }}
                />
                List Of Corporate SCs But Not Regular Corporate
              </div>

              <div style={{ fontSize: 10, fontWeight: "bolder", marginTop: 10 }} className="col-md-4 col-lg-3 col-xl-3 col-sm-6 col-12">
                <Checkbox
                  color="primary"
                  checked={showOnlyClaimable}
                  onChange={() => setShowOnlyClaimable(!showOnlyClaimable)}
                />
                Show only Claimable
              </div>
              <div style={{ marginRight: "auto" }} className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-12">
                <br />
                <Button
                  onClick={() => {
                    set_loading(true);

                    get_data(
                      2,
                      cceid,
                      url,
                      withoutcce.withoutcce ? 1 : 0,
                      "",
                      countryId,
                      freedomain.freedomain ? 1 : 0,
                      forrevival.forrevival ? 1 : 0,
                      month.month === 0 ? 12 : month.month,
                      nr.nr === 0 ? 0 : nr.nr,
                      nrLess.nrLess === 0 ? 0 : nrLess.nrLess,
                      managerid,
                      corporatescbutnotregularcorporate.corporatescbutnotregularcorporate ? 1 : 0
                    );
                  }}
                  size="mini"
                  className="rcb-apply-btn"
                  style={{
                    float: "right",
                    background: "linear-gradient(135deg, #1e293b, #334155)",
                    color: "#fff",
                    borderRadius: "7px",
                    fontWeight: 600,
                    padding: "8px 24px",
                    fontSize: "12.5px",
                    border: "none",
                  }}
                >
                  <Icon name="search" style={{ color: "#fff", margin: "0 6px 0 0" }} />
                  Apply Filters
                </Button>
              </div>


            </div>
          </div>

          {/* ===== INFO TIPS ===== */}
          <div className={classes.infoTip}>
            <strong style={{ color: "#d97706" }}>Tip:</strong> When selling to a new prospect there is a 5-20% chance of making the sale. With an existing customer, that skyrockets to 60-70%. Focusing on existing customers makes it easier to sell and grow business.
          </div>
          <div className={classes.infoTip} style={{ marginBottom: "14px" }}>
            <strong style={{ color: "#d97706" }}>Important:</strong> After adding or claiming a corporate, ensure all associated client email IDs used for releasing SCs are correctly mapped. This will ensure accurate NR and RCI.
          </div>

          {/* ===== SEARCH BAR ===== */}
          <div className={classes.searchBarWrapper}>
            <span style={{ fontSize: "12px", color: "#94a3b8", fontWeight: 500 }}>
              Showing {data_list.length} records
            </span>
            <span className="rcb-search-input">
              <Input
                onChange={handleSearch}
                icon="search"
                placeholder="Search by CCE, URL, Country..."
                style={{
                  width: "300px",
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
          {/* <div> */}
          <Segment style={{ display: "none" }}>
            <Modal
              open={opentenplus}
              onClose={() => setOpenTenPlus(false)}
              closeIcon={<Icon color="red" name="window close" />}
              onOpen={() => setOpenFeedback(true)}
              trigger={
                <BSTooltip title="Corporates with 10 lacs plus" size="small">
                  <Button
                    onClick={() => {
                      getTenPlus("1000000");
                    }}
                    style={{ width: "12vw", float: "left" }}
                    ui
                    attached
                    size="mini"
                  >
                    Corporates with 10 lacs plus
                  </Button>
                </BSTooltip>
              }
            >
              <Modal.Header>10 lacs plus details</Modal.Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  <TableContainer
                    component={Paper}
                    className={classes.container}
                  >
                    <Table
                      id="PopUpTenPlus"
                      size="small"
                      aria-label="a sticky dense table"
                      stickyHeader
                    >
                      <TenPlusTable />
                      <TableBody>
                        {modalTenPlus.map((d) => {
                          return (
                            <TableRow key={d.id} hover>
                              <TableCell
                                component="th"
                                // id={labelId}
                                scope="row"
                                padding="none"
                                align="center"
                              >
                                {d.UserName}
                              </TableCell>
                              <TableCell align="center">{d.URL}</TableCell>
                              <TableCell align="center">{d.TotalNR}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </Segment>
          {/* </div> */}

          <Modal
            open={openReasonPopup}
            onClose={() => setOpenReasonPopup(false)}
            closeIcon={<Icon color="red" name="window close" className="reason-popup-close" />}
            size="mini"
            className="reason-popup-modal"
          >
            <Modal.Header style={{ fontSize: "14px", padding: "10px 15px" }}>Reason for Second Domain</Modal.Header>
            <Modal.Content style={{ padding: "15px" }}>
              <p style={{ fontSize: "13px", margin: 0 }}>{reasonPopupText}</p>
            </Modal.Content>
          </Modal>

          {/* Claimable reason modal — opens when user clicks the green 'Claimable' badge on a row. */}
          <Modal
            open={openClaimableReason}
            onClose={() => setOpenClaimableReason(false)}
            closeIcon={<Icon color="red" name="window close" />}
            size="small"
          >
            <Modal.Header style={{ fontSize: "15px" }}>
              Why is this corporate Claimable?
            </Modal.Header>
            <Modal.Content style={{ padding: "18px" }}>
              {(() => {
                const row = claimableReasonRow || {};
                const info = row._claimableInfo || {};
                const fmt = (d) => d ? new Date(d).toLocaleString() : <span style={{ color: "#94a3b8" }}>— never in window —</span>;
                return (
                  <div style={{ fontSize: "13px", color: "#333" }}>
                    <p><b>Corporate:</b> {row.URL}{row.CorporateName ? " (" + row.CorporateName + ")" : ""}</p>
                    <p><b>Currently mapped to CSM:</b> {row.UserName}</p>
                    <p style={{ marginTop: "10px" }}>
                      This corporate is flagged Claimable because <b>none</b> of the three engagement signals have occurred in the last <b>2 months</b> across any of its mapped contacts:
                    </p>
                    <table cellPadding="6" cellSpacing="0" style={{ borderCollapse: "collapse", fontSize: "13px", marginTop: "6px" }}>
                      <tbody>
                        <tr style={{ background: "#f3f4f6" }}>
                          <td style={{ border: "1px solid #e5e7eb", fontWeight: 600 }}>Latest concrete MOM</td>
                          <td style={{ border: "1px solid #e5e7eb" }}>{fmt(info.LatestMOMDate)}</td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid #e5e7eb", fontWeight: 600 }}>Latest client-reply email</td>
                          <td style={{ border: "1px solid #e5e7eb" }}>{fmt(info.LatestEmailDate)}</td>
                        </tr>
                        <tr style={{ background: "#f3f4f6" }}>
                          <td style={{ border: "1px solid #e5e7eb", fontWeight: 600 }}>Latest verified Teams meeting</td>
                          <td style={{ border: "1px solid #e5e7eb" }}>{fmt(info.LatestTeamsDate)}</td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid #e5e7eb", fontWeight: 600 }}>Contacts mapped</td>
                          <td style={{ border: "1px solid #e5e7eb" }}>{info.ContactCount || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ marginTop: "12px", fontSize: "11px", color: "#6b7280" }}>
                      Snapshot computed at: {info.LastComputedAt ? new Date(info.LastComputedAt).toLocaleString() : "—"}. This flag refreshes nightly via the RCBInactiveCleanup service.
                    </p>
                  </div>
                );
              })()}
            </Modal.Content>
          </Modal>

          <div className="rcb-table-wrapper">
            <TableContainer component={Paper} className={classes.container}>
              <Table
                id="MainData"
                size="small"
                stickyHeader
                style={{ width: "100%" }}
              >
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {recordsAfterPagingAndSorting()
                    .filter((row) => !showOnlyClaimable || row._isClaimable)
                    .map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        textAlign="center"
                      >
                        {row.UserName}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        textAlign="center"
                      >
                        {row.URL}
                        {(row._additionalDomains || []).map((d, i) => (
                          <span key={i}>
                            <br />
                            <span style={{ color: "#2563eb", fontSize: "12px" }}>{d.Domain}</span>
                            {d.Reason && (
                              <a
                                style={{ marginLeft: "5px", fontSize: "11px", cursor: "pointer", color: "#dc2626", textDecoration: "underline" }}
                                onClick={() => { setReasonPopupText(d.Reason); setOpenReasonPopup(true); }}
                              >
                                View Reason
                              </a>
                            )}
                          </span>
                        ))}
                        <br />
                        <b>{row.CorporateName}</b>
                        {/* <b dangerouslySetInnerHTML={{ __html: row.Sensitive }}></b><br></br>
                        <a style={{ display: row.Sensitive ? 'initial' : 'none' }} className="badge btn btn-outline-primary" onClick={() => ViewReason(row.SensitiveReason)}>View Reason</a> */}

                        {row._isClaimable && (
                          <span
                            onClick={() => openClaimableReasonFor(row)}
                            title="Click to see why this corporate is claimable"
                            style={{
                              display: "inline-block",
                              marginLeft: "8px",
                              padding: "2px 8px",
                              borderRadius: "10px",
                              backgroundColor: "#16a34a",
                              color: "#fff",
                              fontSize: "11px",
                              fontWeight: 600,
                              cursor: "pointer",
                              verticalAlign: "middle",
                            }}
                          >
                            Claimable
                          </span>
                        )}

                        <a
                          style={{ display: row.UserId && row.UserId.toString() === userid.toString() ? 'inline-block' : 'none' }}
                          className="rcb-find-contacts"
                          onClick={() => handleFindAdditionalContacts(row.URL, row.CorporateID, row.UserId, row.CountryName)}>
                          Find Additional Contacts
                        </a>

                      </TableCell>
                      <TableCell component="th" scope="row" padding="none" textAlign="center">
                        {row.AllocationDate}
                      </TableCell>
                      <TableCell component="td" scope="row" padding="none">
                        <span className="rcb-nr-value">{row.TotalNR}</span>
                      </TableCell>

                      <TableCell
                        component="td"
                        scope="row"
                        padding="none"
                        style={{ display: "none" }}
                      >
                        {row.TotalNR1}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        textAlign="center"
                      >
                        <span className="rcb-frequency">{row.Frequency}</span>
                      </TableCell>


                      <Modal
                        open={openclientsforurl}
                        onClose={() => {
                          setOpenClientsForUrl(false);
                          setUrl("");
                          set_IndustryId(0);
                          set_Empanel(0);
                          set_CountryId(0);
                          set_Marquee(0);
                          setFile("");
                          set_CommonName("");
                          TempClient([]);
                          set_CCEId(0);
                          setOpenAddCorporate(false);
                        }}
                        closeIcon={<Icon color="red" name="window close" />}
                        trigger={
                          <BSTooltip
                            title="click to see client details"
                            size="small"
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                              textAlign="center"
                            >
                              <span
                                className="rcb-client-link"
                                onClick={() => {
                                  getModalClientsForURL(
                                    4,
                                    row.CorporateID,
                                    userid
                                  );
                                  setUrl(row.URL);
                                  set_PotentialRevenu(row.PotentialRevenue);
                                  set_NoofEmp(row.NoofEmployee);
                                }}
                              >
                                {row.totalContact}
                              </span>
                            </TableCell>
                          </BSTooltip>
                        }
                      >
                        <Modal.Header>Clients for {url}</Modal.Header>
                        <Modal.Content scrolling>
                          <Modal.Description>
                            <TableContainer
                              component={Paper}
                              className={classes.container}
                            >
                              <Table
                                id="PopUpFeedback"
                                className="table table-bordered table-responsive table-striped"
                                size="sm"
                                stickyHeader
                              >
                                <URLClientsTable />
                                <TableBody>
                                  {modalClientsForUrl.map((d) => {
                                    return (
                                      <TableRow key={d.id} hover>
                                        <TableCell
                                          component="th"
                                          // id={labelId}
                                          scope="row"
                                          padding="none"
                                          align="center"
                                        >
                                          {d.ClientName}
                                        </TableCell>
                                        <TableCell align="center">
                                          {d.ClientEmail}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                  {modalClientsForUrl.length === 0 && (
                                    <TableRow>
                                      {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                                      <TableCell
                                        colSpan={3}
                                        component="th"
                                        scope="row"
                                        padding="none"
                                        textAlign="center"
                                        style={{ fontSize: "2rem" }}
                                      >
                                        No data
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Modal.Description>
                        </Modal.Content>
                      </Modal>

                      <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        textAlign="center"
                        style={{ width: "4vw !important" }}
                      >
                        <span className="rcb-country">{row.CountryName}</span>
                      </TableCell>

                      {/* <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        textAlign="center"
                        style={{ width: "4vw !important" }}
                      >
                        {row.PotentialRevenue}
                      </TableCell> */}
                      {/* <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        textAlign="center"
                        style={{ width: "4vw !important" }}
                      >
                        {row.NoofEmployee}
                      </TableCell> */}

                      <TableCell className="rcb-actions-cell">
                        <Modal
                          open={openeditcorporate}
                          onClose={() => {
                            setOpenEditCorporate(false);
                            setUrl("");
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                          }}
                          // onOpen={() => setOpenEditCorporate(true)}
                          closeIcon={<Icon color="red" name="window close" />}
                          trigger={
                            <BSTooltip title="Edit Corporate" size="small">
                              <Button
                                className="rcb-action-btn rcb-btn-edit"
                                size="mini"
                                onClick={async () => {
                                  await IsManager(row.UserId ? row.UserId.toString() : '', userid.toString() || '');
                                  (userid.toString() === "4562" ||
                                    userid.toString() === "4669" ||
                                    userid.toString() === "221" ||
                                    userid.toString() === "4595" ||
                                    userid.toString() === "4819" ||
                                    userid.toString() === "1574" ||
                                    userid.toString() === "6167" ||
                                    userid.toString() === "17545" ||
                                    row.UserId == null || userid.toString() === row.UserId.toString() ||
                                    ismanager.ismanager)
                                    ? edit(row)
                                    : alert("Not your corporate");
                                }}
                              >
                                <Icon name="edit" style={{ margin: "0 4px 0 0", color: "#2563eb" }} />Edit
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>Update Corporate</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              <div style={{ height: "70vh", maxWidth: "75vw" }}>
                                <div
                                  className={classes.divStyle}
                                  style={{ marginBottom: "0px" }}
                                >
                                  <Input
                                    style={{ width: "30vw" }}
                                    value={url}
                                    disabled
                                  />
                                  <div style={{ color: "red", fontSize: "12px" }}>* URL cannot be modified. For any correction, please contact the Development Team with prior approval.</div>
                                </div>
                                <div
                                  className={classes.divStyle}
                                  style={{ marginBottom: "0px" }}
                                >
                                  <div style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                                    <b style={{ fontSize: "13px" }}>Additional Domains (Optional)</b>
                                    <Button
                                      size="mini"
                                      primary
                                      onClick={addDomainRow}
                                      style={{ marginLeft: "10px" }}
                                    >
                                      <Icon name="plus" /> Add Domain
                                    </Button>
                                  </div>
                                  {additionalDomains.map((d, idx) => (
                                    <div key={idx} style={{ marginBottom: "10px", padding: "8px", border: "1px solid #e5e7eb", borderRadius: "6px" }}>
                                      <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                        <Input
                                          placeholder="Enter Additional Domain (e.g. @company.com)"
                                          style={{ width: "26vw" }}
                                          value={d.Domain}
                                          onChange={(e) => updateDomainField(idx, "Domain", e.target.value)}
                                        />
                                        <Button
                                          size="mini"
                                          negative
                                          icon
                                          onClick={() => removeDomainRow(idx)}
                                          style={{ marginLeft: "8px" }}
                                          title="Remove this domain"
                                        >
                                          <Icon name="trash" />
                                        </Button>
                                      </div>
                                      <div style={{ color: "red", fontSize: "11px", marginBottom: "3px" }}>* Bonafide reason for this additional domain</div>
                                      <Input
                                        placeholder="Reason (e.g. Acquired subsidiary uses this domain)"
                                        style={{ width: "30vw" }}
                                        value={d.Reason}
                                        onChange={(e) => updateDomainField(idx, "Reason", e.target.value)}
                                      />
                                    </div>
                                  ))}
                                </div>
                                <div className={classes.divStyle}>
                                  <Dropdown
                                    placeholder="Select Industry"
                                    fluid
                                    search
                                    scrolling
                                    value={industryId}
                                    onChange={(e, { value }) => {
                                      set_IndustryId(value);
                                      set_IndustryName(e.target.text);
                                    }}
                                    options={industry}
                                    selection
                                    clearable
                                  />
                                </div>
                                <div className={classes.divStyle}>
                                  <Dropdown
                                    placeholder="Select CCE"
                                    fluid
                                    search
                                    scrolling
                                    value={cceid}
                                    onChange={(e, { value }) => {
                                      set_CCEId(value);
                                      set_CCEName(e.target.text);
                                    }}
                                    selection
                                    options={cce}
                                    clearable
                                  />
                                </div>
                                <div className={classes.divStyle}>
                                  <Dropdown
                                    placeholder="Select Country"
                                    fluid
                                    search
                                    scrolling
                                    value={countryId}
                                    onChange={(e, { value }) => {
                                      set_CountryId(value);
                                      set_CountryName(e.target.text);
                                    }}
                                    selection
                                    options={country}
                                    clearable
                                  />
                                </div>
                                <div
                                  className={classes.divStyle}
                                  style={{ width: "20vw" }}
                                >
                                  <label>Logo : </label>
                                  <Button onClick={handleUpload} size="mini">
                                    <Icon color="teal" name="upload" />
                                  </Button>
                                  <input
                                    id="updateFilercbLogo"
                                    type="file"
                                    style={{ marginLeft: "1em" }}
                                    onChange={(e) => {
                                      handleChangelogo(e);
                                    }}
                                    ref={fileInput}
                                  //value=""
                                  />
                                </div>
                                {/* <div style={{ width: "5vw" }}>
                        <Button
                          onClick={() => {
                            
                          }}
                          size="mini"
                        >
                          <Icon color="teal" name="upload" />
                        </Button>
                      </div> */}
                                <div
                                  className={classes.divStyle}
                                  style={{
                                    width: "10vw",
                                    height: "10vh",
                                    marginBottom: "0vh",
                                  }}
                                  onClick={() => handleRemove()}
                                >
                                  {/* {file && <ImageThumb image={file} />} */}
                                  {/* {getDownloadPP(file.name?file.name:file)} */}
                                  {/* (file !== null &&
                                          file !== "undefined" &&
                                          file !== ""
                                          ? file.name
                                          : "") */}
                                  {file && source && (
                                    <img
                                      id="updateImgrcbLogo"
                                      src={source ? source : null}
                                      alt={file ? file : null}
                                      style={{
                                        transform: "scale(5)!important",
                                      }}
                                    // onClick={onclick}
                                    />
                                  )}
                                </div>


                                <div
                                  className={classes.divStyle}
                                  style={{ marginBottom: "0px" }}
                                >
                                  <label>Common Name</label>
                                  <Input
                                    value={commonname}
                                    style={{ width: "30vw" }}
                                    onChange={handleInputCommonName}
                                  />
                                </div>
                                <div className={classes.divStyle}>
                                  <label>Potential Revenue</label>
                                  <Input
                                    style={{ width: "30vw" }}
                                    value={PotentialRevenu}
                                    onChange={handleInputPotential}

                                  />
                                </div>
                                <div
                                  className={classes.divStyle}
                                  style={{
                                    marginTop: "-10px",
                                    marginBottom: "0px",

                                  }}
                                >
                                  <label># of Employee</label>
                                  <Input
                                    style={{ width: "30vw" }}
                                    value={NoofEmp}
                                    onChange={handleInputNoofEmployee}

                                  />

                                </div>
                                <div
                                  className={classes.divStyle}
                                  style={{
                                    marginTop: "-10px",
                                    marginBottom: "0px",

                                  }}
                                >
                                  <label>Vendor Code</label>
                                  <Input
                                    style={{ width: "30vw" }}
                                    value={VenddorCode}
                                    onChange={handleInputVendorCode}

                                  />

                                </div>
                                <div
                                  class="custom-control custom-checkbox custom-control-inline"
                                  className={classes.divStyle}
                                >
                                  <div
                                    style={{ visibility: "hidden" }}
                                    class="custom-control custom-checkbox custom-control-inline"
                                  >
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      id="addforRevival"
                                    />
                                    <label
                                      class="custom-control-label"
                                      for="addforRevival"
                                    >
                                      For Revival
                                    </label>
                                  </div>
                                  <div class="custom-control custom-checkbox custom-control-inline">
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      id="addmarquee"
                                      onChange={() => {
                                        set_Marquee({
                                          marquee: !marquee.marquee,
                                        });
                                      }}
                                      checked={marquee.marquee}
                                    />
                                    <label
                                      class="custom-control-label"
                                      for="addmarquee"
                                    >
                                      Marquee
                                    </label>
                                  </div>
                                  <div class="custom-control custom-checkbox custom-control-inline">
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      id="addEmpanelment"
                                      onChange={() => {
                                        set_Empanel({
                                          empanel: !empanel.empanel,
                                        });
                                      }}
                                      checked={empanel.empanel}
                                    />
                                    <label
                                      class="custom-control-label"
                                      for="addEmpanelment"
                                    >
                                      Empanelment done
                                    </label>
                                  </div>
                                  <div class="custom-control custom-checkbox custom-control-inline">
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      id="addNotEmpanelment"
                                    />
                                    <label
                                      class="custom-control-label"
                                      for="addNotEmpanelment"
                                    >
                                      Empanelment not required
                                    </label>
                                  </div>
                                </div>
                                <div className={classes.divStyle}>
                                  <div style={{ color: "red", fontSize: "12px", marginBottom: "5px" }}>* Only Client Email IDs with the same domain as the RC Domain can be added.<br />* Type at least 3 characters after @ to get the dropdown options for selecting the Email ID.</div>
                                  <div style={{ margin: 10 }}>
                                    <div className="divSearchBoxDesktop">
                                      <div className="divSearchBarDesktop">
                                        <span className="SearchBarDesktop">
                                          <Input
                                            onChange={(t) => {
                                              search(t.target.value);
                                              set_ClientName(t.target.value);
                                            }}
                                            value={clientname}
                                            //className="inputSearchDesktop"
                                            style={{ width: "500px" }}
                                            placeholder="Enter Contacts"
                                            icon={
                                              <Icon
                                                name="delete"
                                                link
                                                onClick={handleInputDeleteClick}
                                              />
                                            }
                                          />
                                        </span>
                                        <span className="SearchBoxItemDesktop">
                                          <Table>
                                            {searchResults.map((item) => {
                                              return (
                                                <span
                                                  key={item.value}
                                                  onClick={() => {
                                                    set_ClientId(item.key);
                                                    // set_ClientName(e.target.innerText);
                                                    // ClientExistOrNot(
                                                    //   item.value
                                                    // );
                                                    // if (
                                                    //   setclientexistornot.setclientexistornot ===
                                                    //   true
                                                    // ) {
                                                    //   alert(
                                                    //     "this client linked with another corporate"
                                                    //   );
                                                    //   return;
                                                    // }

                                                    //ddd[0].URL

                                                    const newList = tempclient.concat(
                                                      {
                                                        name: item.text,
                                                        id: item.value,
                                                      }
                                                    );

                                                    const newList1 = newList.filter(
                                                      (x, i) => x.name !== ""
                                                    );

                                                    let mymap = new Map();

                                                    const newList2 = newList1.filter(
                                                      (el) => {
                                                        const val = mymap.get(
                                                          el.name
                                                        );

                                                        if (val) {
                                                          if (el.id < val) {
                                                            mymap.delete(
                                                              el.name
                                                            );
                                                            mymap.set(
                                                              el.name,
                                                              el.id
                                                            );
                                                            return true;
                                                          } else {
                                                            return false;
                                                          }
                                                        }
                                                        mymap.set(
                                                          el.name,
                                                          el.id
                                                        );
                                                        return true;
                                                      }
                                                    );

                                                    TempClient(newList2);

                                                    // set_ClientId(0);
                                                    // set_ClientName("");
                                                    set_show_list("none");
                                                    setSearchResults([]);
                                                  }}
                                                  className="listSearchDesktop"
                                                >
                                                  {item.text}
                                                </span>
                                              );
                                            })}
                                          </Table>
                                        </span>
                                        <div className="divSelectNumberDesktop"></div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* <ClientDropDown
                                    scrolling
                                    passChildData={(clientname, clientid) => {
                                      set_ClientId(clientid);
                                      set_ClientName(clientname);

                                      const newList = tempclient.concat({
                                        name: clientname,
                                        id: clientid,
                                      });

                                      const newList1 = newList.filter(
                                        (x, i) => x.name !== ""
                                      );

                                      let mymap = new Map();

                                      const newList2 = newList1.filter((el) => {
                                        const val = mymap.get(el.name);

                                        if (val) {
                                          if (el.id < val) {
                                            mymap.delete(el.name);
                                            mymap.set(el.name, el.id);
                                            return true;
                                          } else {
                                            return false;
                                          }
                                        }
                                        mymap.set(el.name, el.id);
                                        return true;
                                      });

                                      TempClient(newList2);

                                      set_ClientId(0);
                                      set_ClientName("");
                                    }}
                                  /> */}
                                  <TableContainer
                                    component={Paper}
                                    style={{ maxHeight: 350 }}
                                  >
                                    <Table
                                      id="PopUpTempClients"
                                      className="table table-bordered table-responsive table-striped"
                                      size="sm"
                                      stickyHeader
                                    >
                                      <URLClientsTableTemp />
                                      <TableBody>
                                        {tempclient.map((d) => {
                                          return (
                                            <TableRow hover key={d.id}>
                                              <TableCell
                                                component="th"
                                                // id={labelId}
                                                scope="row"
                                                padding="none"
                                                align="center"
                                              >
                                                {d.name}
                                              </TableCell>
                                              <TableCell>
                                                <Button
                                                  onClick={() =>
                                                    handleRemovetemp(d.id)
                                                  }
                                                  icon
                                                  size="mini"
                                                  style={{ marginRight: "3em" }}
                                                >
                                                  <Icon name="close icon" />
                                                </Button>
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                        {tempclient.length === 0 && (
                                          <TableRow>
                                            {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                                            <TableCell
                                              colSpan={2}
                                              component="th"
                                              scope="row"
                                              padding="none"
                                              textAlign="center"
                                              style={{ fontSize: "2rem" }}
                                            >
                                              No data
                                            </TableCell>
                                          </TableRow>
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                                <div className={classes.divStyle}>
                                  <Button
                                    icon
                                    labelPosition="right"
                                    floated="right"
                                    size="huge"
                                    style={{ marginRight: "3em" }}
                                    onClick={async () => {
                                      if (url === null || url === "") {
                                        alert("URL should not be blank");
                                        return;
                                      }
                                      debugger;
                                      if (
                                        (file !== null &&
                                          file !== "undefined" &&
                                          file !== "") &&
                                        ((!imgupload && imgupload1) || (imgupload && !imgupload1))
                                      ) {
                                        alert(
                                          "you should click Upload before update as you have select an image file"
                                        );
                                        return;
                                      }

                                      // set_source(null);
                                      // saveRCLogo(file);

                                      if (additionalDomains.length > 0) {
                                        set_loading(true);
                                        const aiCheckAll = await validateAllDomainsAI(additionalDomains);
                                        set_loading(false);
                                        if (!aiCheckAll.valid) { alert(aiCheckAll.message); return; }
                                      }

                                      let tblSaveRCB = [];

                                      let objSaveRCB = {
                                        _URLId: urlId,
                                        _Url: originalUrlRef.current,
                                        _industryId:
                                          industryId !== null ? industryId : 0,
                                        _empanel: empanel.empanel ? 1 : 0,
                                        _countryId:
                                          countryId !== null ? countryId : 0,
                                        _marquee: marquee.marquee ? 1 : 0,
                                        _file:
                                          file !== null &&
                                            file !== "undefined" &&
                                            file !== ""
                                            ? file.name
                                              ? file.name
                                              : file
                                            : "",
                                        _userid: userid !== null ? userid : 0,
                                        _commonname:
                                          commonname !== null ? commonname : "",
                                        _tempclient: JSON.stringify(tempclient.map(c => ({ id: c.id }))),
                                        //   _tempclient: JSON.stringify(tempclient),
                                        _cceid: cceid !== null ? cceid : 0,
                                        _PotentialRevenu: PotentialRevenu != null ? PotentialRevenu : 0,
                                        _NoofEmp: NoofEmp != null ? NoofEmp : 0,
                                        _VendorCode: VenddorCode != null ? VenddorCode : 0,
                                        // Multi-domain lives in the new child table — clear the legacy columns.
                                        _SecondURL: "",
                                        _SecondURLReason: "",
                                      };
                                      tblSaveRCB.push(objSaveRCB);
                                      await save_data(tblSaveRCB);
                                      // Persist the domain list (UrlID is known in the Edit flow).
                                      await persistAdditionalDomains(urlId, originalUrlRef.current, cceid !== null ? cceid : 0);
                                      setAdditionalDomains([]);
                                      // alert("action completed");
                                      // set_loading(false);
                                      setUrl("");
                                      set_IndustryId(0);
                                      set_Empanel(0);
                                      set_CountryId(0);
                                      set_Marquee(0);
                                      setFile("");
                                      set_CountryId("");
                                      TempClient([]);
                                      set_CCEId(0);
                                      set_CCE(prev => prev.filter(opt => !opt.temp));
                                      setOpenEditCorporate(false);
                                      set_CommonName("");
                                      set_UrlId(0);
                                      setSecondUrl("");
                                      setSecondUrlReason("");
                                      setImageUpload(false);
                                      setImageUpload1(false);
                                    }}
                                  >
                                    Update
                                    <Icon name="save" />
                                  </Button>
                                </div>
                              </div>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>

                        {/* RCB Claim-from-CSM modal -------------------------------------- */}
                        <Modal
                          open={openClaimModal}
                          onClose={closeClaimModal}
                          size="large"
                          closeIcon={<Icon color="red" name="window close" />}
                        >
                          <Header icon="exchange" content="Claim contact from another CSM" />
                          <Modal.Content>
                            <p style={{ marginBottom: 12 }}>
                              One or more contacts you tried to save are already mapped to another CSM.
                              Click <b>Claim</b> to attempt a transfer — the system checks Outlook reply
                              history and verified Teams meeting attendance for both CSMs, and only
                              transfers if your activity is more recent.
                            </p>
                            <TableContainer component={Paper} style={{ maxHeight: 420 }}>
                              <Table size="small" stickyHeader>
                                <TableHead>
                                  <TableRow>
                                    <TableCell><b>Contact email</b></TableCell>
                                    <TableCell><b>Currently mapped to</b></TableCell>
                                    <TableCell><b>Status</b></TableCell>
                                    <TableCell align="center"><b>Action</b></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {claimConflicts.length === 0 && (
                                    <TableRow>
                                      <TableCell colSpan={4} align="center" style={{ padding: 20 }}>
                                        No conflicts to resolve.
                                      </TableCell>
                                    </TableRow>
                                  )}
                                  {claimConflicts.map((c, idx) => {
                                    const fmt = (d) => d ? new Date(d).toLocaleString() : "—";
                                    let statusEl = null;
                                    if (c.status === "pending") statusEl = <span>Ready</span>;
                                    else if (c.status === "checking") statusEl = (
                                      <span><Icon loading name="spinner" /> Checking Outlook / Teams + transferring…</span>
                                    );
                                    else if (c.status === "done") statusEl = (
                                      <span style={{ color: "green" }}>
                                        <Icon name="check" /> Claimed. Your last: {fmt(c.newDate)} / theirs: {fmt(c.oldDate)}
                                      </span>
                                    );
                                    else if (c.status === "rejected") statusEl = (() => {
                                      const csm1 = c.csm1 || {};
                                      const signals = csm1.signals || {};
                                      const stillActiveOn = [];
                                      if (signals.mom)   stillActiveOn.push(`concrete MOM on ${fmt(csm1.latestConcreteMOM)}`);
                                      if (signals.email) stillActiveOn.push(`client reply on ${fmt(csm1.latestClientReply)}`);
                                      if (signals.teams) stillActiveOn.push(`Teams meeting on ${fmt(csm1.latestVerifiedTeamsMeeting)}`);
                                      if (signals.nr)    stillActiveOn.push(`NR ${csm1.nrSumLast6Months} in last 6 months`);
                                      const text =
                                        c.reason === "CSM1StillActive"
                                          ? `Other CSM is still active — ${stillActiveOn.join(', ') || 'signals present'}. Claim denied.`
                                          : c.reason === "CSM2NoRecentReply"
                                            ? "You have no client reply from this contact in the last 2 months. Claim denied."
                                            : c.reason === "NoActivePriorMapping"
                                              ? "Could not find an active prior mapping for this contact."
                                              : c.reason === "NewCSMEmailNotFound"
                                                ? "Your office email could not be resolved. Please contact RMS support."
                                                : `Rejected: ${c.reason}`;
                                      return (
                                        <span style={{ color: "#b94a48" }}>
                                          <Icon name="ban" /> {text}
                                        </span>
                                      );
                                    })();
                                    else if (c.status === "error") statusEl = (
                                      <span style={{ color: "#b94a48" }}>
                                        <Icon name="warning sign" /> {c.reason || "Error"}
                                      </span>
                                    );

                                    // newCorporateID may be 0 on the Add-new path; backend will resolve from URL+CSM.
                                    const disabled = !c.clientEmail || !c.corporateUrl ||
                                                     c.status === "checking" || c.status === "done";

                                    return (
                                      <TableRow key={idx} hover>
                                        <TableCell style={{ fontSize: 12 }}>{c.clientEmail}</TableCell>
                                        <TableCell>{c.oldCSMName}</TableCell>
                                        <TableCell>{statusEl}</TableCell>
                                        <TableCell align="center">
                                          <Button
                                            size="mini"
                                            primary
                                            disabled={disabled}
                                            onClick={() => handleClaim(idx)}
                                          >
                                            Claim
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Modal.Content>
                          <Modal.Actions>
                            <Button onClick={closeClaimModal}>
                              Close
                            </Button>
                          </Modal.Actions>
                        </Modal>
                        {/* end Claim-from-CSM modal -------------------------------------- */}

                        <Modal
                          open={openexpand}
                          //onOpen={() => setOpenExpand(true)}
                          onClose={() => {
                            setOpenExpand(false);
                            setUrl("");
                            set_NoOfDays(0);
                            set_LastCCE(0);
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_cceEmailId('');
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                            get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
                          }}
                          closeIcon={<Icon color="red" name="window close" />}
                          trigger={
                            <BSTooltip title="Claim Corporate" size="small">
                              <Button
                                className="rcb-action-btn rcb-btn-claim"
                                size="mini"
                                onClick={() => {
                                  console.log(row)
                                  setSelectedRow(row);
                                  setUrl(row.URL);
                                  set_UrlId(row.CorporateID)
                                  set_NoOfDays(row.NoOfDays)
                                  set_LastCCE(row.LastCCE)
                                  set_cceEmailId(row.CCEEmailId)
                                  //setOpenExpand(true);
                                  const confirmation = window.confirm('As per the new RC (Regular Corporate) Policy, kindly commit a minimum of 10 lac NR in the next 6 months or 50% more than your current commitment to proceed with the corporate claim.');

                                  if (confirmation) {
                                    setOpenExpand(true);
                                  } else {
                                    // Cancelled action
                                    console.log('Action cancelled.');
                                  }
                                }}
                              >
                                <Icon name="hand point right" style={{ margin: "0 4px 0 0", color: "#059669" }} />{row.UserId === null ? 'Claim' : 'Claim'}
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>Dormant Corporate</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              <div>
                                <TextArea
                                  id="txtareaClaim"
                                  rows={2}
                                  placeholder="Mention reason you want to acquire this corporate"
                                  style={{
                                    width: "75vw",
                                    height: "55vh",
                                    margin: 23,
                                    fontSize: "26px",
                                    padding: "10px",
                                  }}
                                  onChange={handleTextAreaReserve}
                                />
                              </div>
                              <div>
                                <Button
                                  icon
                                  labelPosition="right"
                                  floated="right"
                                  size="huge"
                                  style={{ marginRight: "3em" }}
                                  onClick={async () => {
                                    if (txtareareserve == '') {
                                      alert('please mention the reason.')
                                    }
                                    else {
                                      set_loading(true)
                                      setUrl(url);
                                      console.log("@ " + NoOfDays + " & " + row.UserId + " * " + row.TotalNR1 + " $ " + row.CorporateName)
                                      console.log(selectedRow)
                                      // claimed stays true when no transfer was attempted (the >365 days
                                      // case only sends a request mail, it does not transfer ownership)
                                      let claimed = true;
                                      if (selectedRow.UserId === null && LastCCE != userid) {
                                        // console.log(urlId)
                                        // console.log(userid)
                                        claimed = await transferCorporate(urlId, userid)
                                      }

                                      if (claimed && (selectedRow.UserId === null || NoOfDays >= 365) && LastCCE != userid) {
                                        console.log('inside mail sent')
                                        sendMailForReserve(
                                          useremailid,
                                          "CSM@koenig-solutions.com;cce@koenig-solutions.com;OverseasSales@koenig-solutions.com;flsales@koenig-solutions.com;DomesticSales@koenig-solutions.com;CorporateSales@koenig-solutions.com;",
                                          (selectedRow.UserId === null ? useremailid : useremailid + ";" + cceEmailId),
                                          "shubham.verma@koenig-solutions.com;",
                                          (selectedRow.UserId === null ? username + ' has taken ' + url + ' as was without any CCE' : username + ' wants to take ' + url),
                                          (selectedRow.UserId === null ? ` Subjected Corporate is claimed by ` + username + ` and is auto Transferred as not owned by any CCE.<br>` : ` Subjected Corporate is being claimed by ` + username + `, who has expressed their desire to take ownership of it.<br> 
                                        If no objection is raised within 3 days,`+ username + ` you can take the ownership and get it transferred  to yourself.<br> Details on how to carry out the transfer can be found in the FAQ section of the RCB Panel.
                                        However, if an objection is raised within the 3-day period, take permission of your manager before the transfer<br>`) + ' CCE Remark - ' + txtareareserve
                                        );
                                      }
                                      if (!claimed) {
                                        // transferCorporate already showed why it was refused,
                                        // and no mail went out
                                        set_loading(false);
                                      }
                                      else if ((selectedRow.UserId === null || NoOfDays > 365) && LastCCE != userid)
                                        alert("Mail sent succesfully ");
                                      else if (LastCCE == userid) {
                                        alert("You can't claim this corporate as you were the last owner");
                                      }
                                      else
                                        alert("Corporate cannot be claimed as the creation or last claim date is less than 12 months.");
                                    }
                                  }}
                                >
                                  Send mail
                                  <Icon name="paper plane" />
                                </Button>
                              </div>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>

                        <Modal
                          open={openfeedback}
                          onClose={() => {
                            setOpenFeedback(false);
                            setUrl("");
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                          }}
                          closeIcon={<Icon color="red" name="window close" />}
                          // onOpen={() => setOpenFeedback(true)}
                          trigger={
                            <BSTooltip title="View Feedback" size="small">
                              <Button
                                onClick={() => {
                                  getFeedback(row.CorporateID);
                                  setUrl(row.URL);
                                }}
                                className="rcb-action-btn rcb-btn-feedback"
                                size="mini"
                              >
                                <Icon name="comments" style={{ margin: "0 4px 0 0", color: "#7c3aed" }} />Feedback
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>Feedbacks for {url}</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              <TableContainer
                                component={Paper}
                                className={classes.container}
                              >
                                <Table
                                  id="PopUpFeedback"
                                  className="table table-bordered table-responsive table-striped"
                                  size="sm"
                                  stickyHeader
                                >
                                  <FeedbackTable />
                                  <TableBody>
                                    {modalFeedback.map((d) => {
                                      return (
                                        <TableRow key={d.id} hover>
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.AssignmentId + d.Outstanding}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.Date}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.Course}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.Feedback}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                    {modalFeedback.length === 0 && (
                                      <TableRow>
                                        {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                                        <TableCell
                                          colSpan={6}
                                          component="th"
                                          scope="row"
                                          padding="none"
                                          textAlign="center"
                                          style={{ fontSize: "2rem" }}
                                        >
                                          No data
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>

                        <Modal
                          open={opengraph}
                          onClose={() => {
                            setOpenGraph(false);
                            setUrl("");
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                          }}
                          closeIcon={
                            <Icon
                              color="red"
                              name="window close"
                              size="massive"
                            />
                          }
                          trigger={
                            <BSTooltip title="View Graph" size="small">
                              <Button
                                onClick={() => {
                                  getModalGraph(
                                    "6",
                                    row.UserId == null ? 0 : row.UserId,
                                    row.CorporateID
                                  );
                                  getModalUrlCCEs("8", row.CorporateID);
                                  setUrl(row.URL);
                                }}
                                className="rcb-action-btn rcb-btn-graph"
                                size="mini"
                              >
                                <Icon name="chart line" style={{ margin: "0 4px 0 0", color: "#d97706" }} />Graph
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>{url} Graph</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              {/* <Chart
                                width={"65vw"}
                                height={"60vh"}
                                chartType="Line"
                                loader={<div>Loading Chart</div>}
                                data={modalgraphdata}
                                options={{
                                  chart: {
                                    title: "Total NR",
                                    subtitle: " in Rupees(INR))",
                                  },
                                }}
                                rootProps={{ "data-testid": "4" }}
                              /> */}

                              <Chart
                                width={"65vw"}
                                height={"60vh"}
                                chartType="ComboChart"
                                loader={<div>Loading Chart</div>}
                                data={modalgraphdata}
                                options={{
                                  title: "Total NR  in Rupees(INR)",
                                  vAxis: { title: "NR" },
                                  hAxis: { title: "Month" },
                                  seriesType: "line",
                                  series: { 4: { type: "scatter" } },
                                }}
                                rootProps={{ "data-testid": "1" }}
                              />

                              <br />
                              <br />
                              <TableContainer component={Paper}>
                                <Table
                                  id="PopUpURLCCEs"
                                  className="table table-bordered table-responsive table-striped"
                                  size="sm"
                                  stickyHeader
                                  style={{ width: "46vw" }}
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell colSpan="3">
                                        Regular corporate allocated to CCE with
                                        From & To Date
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {urlcce.map((d) => {
                                      return (
                                        <TableRow hover>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.CCE}
                                          </TableCell>
                                          <TableCell align="center">
                                            {d.FDate}
                                          </TableCell>
                                          <TableCell align="center">
                                            {d.TDate}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                    {urlcce.length === 0 && (
                                      <TableRow>
                                        {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                                        <TableCell
                                          colSpan={3}
                                          component="th"
                                          scope="row"
                                          padding="none"
                                          textAlign="center"
                                          style={{ fontSize: "2rem" }}
                                        >
                                          No data
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>

                        <Modal
                          open={openscs}
                          onClose={() => {
                            setOpenSCs(false);
                            setUrl("");
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                          }}
                          closeIcon={<Icon color="red" name="window close" />}
                          // onOpen={() => setOpenFeedback(true)}
                          trigger={
                            <BSTooltip title="Student Cards" size="small">
                              <Button
                                onClick={() => {
                                  getModalSCs(1, row.CorporateID, userid, month);
                                  setUrl(row.URL);
                                }}
                                className="rcb-action-btn rcb-btn-scs"
                                size="mini"
                              >
                                <Icon name="id card" style={{ margin: "0 4px 0 0", color: "#4338ca" }} />SCs
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>{url} student cards</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              <TableContainer
                                component={Paper}
                              // className={classes.container}
                              >
                                <Table
                                  id="PopUpSCs"
                                  className="table table-bordered table-responsive table-striped"
                                  size="sm"
                                  stickyHeader
                                >
                                  <SCsTable />
                                  <TableBody>
                                    {modalSCs.map((d) => {
                                      return (
                                        <TableRow key={d.id} hover>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.scid == null ? (
                                              "N/A"
                                            ) : (
                                              <a
                                                target="_blank"
                                                href={
                                                  "https://rms.koenig-solutions.com/Forms/CRM/student-card-prev.aspx?scid=" +
                                                  d.scid +
                                                  "&PDFTran=pdfwerw12312123xfcg"
                                                }
                                              >
                                                {d.scid}
                                              </a>
                                            )}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.ClientName}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.CreatedOn}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.TotalNR}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                    {modalSCs.length === 0 && (
                                      <TableRow>
                                        {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                                        <TableCell
                                          colSpan={4}
                                          component="th"
                                          scope="row"
                                          padding="none"
                                          textAlign="center"
                                          style={{ fontSize: "2rem" }}
                                        >
                                          No data
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>


                        <Modal
                          open={openQuot}
                          onClose={() => {
                            setOpenQuot(false);
                            setUrl("");
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                          }}
                          closeIcon={<Icon color="red" name="window close" />}
                          // onOpen={() => setOpenFeedback(true)}
                          trigger={
                            <BSTooltip title="Quotations" size="small">
                              <Button
                                onClick={() => {
                                  getModalQuotation(25, row.CorporateID, userid, month);
                                  setUrl(row.URL);
                                }}
                                className="rcb-action-btn rcb-btn-quot"
                                size="mini"
                              >
                                <Icon name="file alternate" style={{ margin: "0 4px 0 0", color: "#0891b2" }} />Quot
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>{url} Quotations (Tentative)</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              <TableContainer
                                component={Paper}
                              // className={classes.container}
                              >
                                <Table
                                  id="PopUpSCs"
                                  className="table table-bordered table-responsive table-striped"
                                  size="sm"
                                  stickyHeader
                                >
                                  <QuotationTable />
                                  <TableBody>
                                    {modalQuotation.map((d) => {
                                      return (
                                        <TableRow key={d.id} hover>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.QuotationId}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.Quotation_status}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.Client}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.TotalNR}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.Pax}
                                          </TableCell>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.Date}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                    {modalQuotation.length === 0 && (
                                      <TableRow>
                                        {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                                        <TableCell
                                          colSpan={4}
                                          component="th"
                                          scope="row"
                                          padding="none"
                                          textAlign="center"
                                          style={{ fontSize: "2rem" }}
                                        >
                                          No data
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>

                        <Modal
                          open={openmoms}
                          onClose={() => {
                            setOpenMOMs(false);
                            setUrl("");
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                          }}
                          closeIcon={<Icon color="red" name="window close" />}
                          trigger={
                            <BSTooltip title="Minutes of Meetings" size="small">
                              <Button
                                onClick={() => {
                                  getModalMOMs(row.UserId, row.CorporateID);
                                  setUrl(row.URL);
                                }}
                                className="rcb-action-btn rcb-btn-moms"
                                size="mini"
                              >
                                <Icon name="clipboard list" style={{ margin: "0 4px 0 0", color: "#ea580c" }} />MOMs
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>{url} meetings</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              <TableContainer
                                component={Paper}
                              // className={classes.container}
                              >
                                <Table
                                  id="PopUpMOMs"
                                  className="table table-bordered table-responsive table-striped"
                                  size="sm"
                                  stickyHeader
                                >
                                  <MOMsTable />
                                  <TableBody>
                                    {modalMOMs.map((d) => {
                                      return (
                                        <TableRow key={d.id} hover>
                                          <TableCell
                                            component="th"
                                            // id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {d.MeetingDate}
                                          </TableCell>
                                          <TableCell align="center">
                                            {d.Remarks}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                    {modalMOMs.length === 0 && (
                                      <TableRow>
                                        {/* style={{ height: (dense ? 33 : 53) * emptyRows }}> */}
                                        <TableCell
                                          colSpan={2}
                                          component="th"
                                          scope="row"
                                          padding="none"
                                          textAlign="center"
                                          style={{ fontSize: "2rem" }}
                                        >
                                          No data
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>
                        <Button
                          onClick={async () => {
                            var clogin = userid ? userid.toString() : '';
                            var rowUserid = row.UserId ? row.UserId.toString() : '';
                            await IsManager(row.UserId ? row.UserId.toString() : '', userid ? userid.toString() : '' || '');

                            //(clogin === rowUserid || ismanager.ismanager)
                            (clogin == 219 || clogin == 17545)
                              ? deleteCorporate(clogin, row.CorporateID)
                              : alert("You do not have access");
                          }}
                          className="rcb-action-btn rcb-btn-delete"
                          size="mini"
                        >
                          <Icon name="trash alternate" style={{ margin: "0 4px 0 0", color: "#dc2626" }} />Delete
                        </Button>
                        <Modal
                          open={openSensitive}
                          //onOpen={() => setOpenExpand(true)}
                          onClose={() => {
                            setOpenSensitive(false);
                            setUrl("");
                            set_NoOfDays(0);
                            set_IndustryId(0);
                            set_Empanel(0);
                            set_cceEmailId('');
                            set_CountryId(0);
                            set_Marquee(0);
                            setFile("");
                            set_CommonName("");
                            TempClient([]);
                            set_CCEId(0);
                            setOpenAddCorporate(false);
                            get_data(2, 0, "", 0, "", selectedCountryId, 0, 0, 12, 0, 0, 0, 0);
                          }}
                          closeIcon={<Icon color="red" name="window close" />}
                          trigger={
                            <BSTooltip title="Mark Sensitive" size="small">
                              <Button
                                className="rcb-action-btn rcb-btn-sensitive"
                                size="mini"
                                style={{ display: (userid == 6521 || userid == 17545) ? 'block' : 'none' }}
                                onClick={() => {
                                  setUrl(row.URL);
                                  set_UrlId(row.CorporateID)
                                  set_NoOfDays(row.NoOfDays)
                                  set_cceEmailId(row.CCEEmailId)
                                  setOpenSensitive(true);
                                }}
                              >
                                <Icon name="shield" style={{ margin: "0 4px 0 0", color: "#64748b" }} />Sensitive
                              </Button>
                            </BSTooltip>
                          }
                        >
                          <Modal.Header>Sensitive Reason</Modal.Header>
                          <Modal.Content scrolling>
                            <Modal.Description>
                              <div>
                                <TextArea
                                  id="txtareaSensitive"
                                  rows={2}
                                  placeholder="Mention reason you want to mark this corporate as sensitive"
                                  style={{
                                    width: "95%",
                                    height: "65vh",
                                    margin: 23,
                                    fontSize: "26px",
                                    padding: "10px",
                                  }}
                                  onChange={handleSensitiveReason}
                                />
                              </div>
                              <div style={{ textAlign: "center" }}>
                                <Button
                                  icon
                                  size="huge"
                                  onClick={() => {
                                    if (sensitiveReason == '') {
                                      alert('please mention the reason.')
                                    }
                                    else {
                                      //set_loading(true)
                                      setUrl(url);
                                      marksensitive(urlId, row);
                                    }
                                  }}
                                >
                                  Save
                                </Button>
                              </div>
                            </Modal.Description>
                          </Modal.Content>
                        </Modal>
                        {/* <Button style={{ display: userid == 6521 ? 'block' : 'none' }}
                          className="ui attached"
                          size="mini"
                          onClick={() => getSweetalert(row.CorporateID, row)}
                        >
                          Sensitive
                        </Button> */}
                      </TableCell>
                    </TableRow>
                  ))}

                  {emptyRows === 20 && (
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        component="th"
                        scope="row"
                        padding="none"
                        className="rcb-no-data"
                      >
                        No data found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <div className="rcb-pagination">
              <TablePagination
                rowsPerPageOptions={[10, 100, 200, 400, data_list.length]}
                component="div"
                count={data_list.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
